import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  IconButton,
  Backdrop,
  CircularProgress,
  Paper,
  Alert,
  Link,
  Autocomplete,
  ListItemText,
  Breadcrumbs,
  Grid,
} from '@mui/material';
import Add from '@mui/icons-material/Add';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { AddBox, Api, Settings } from '@mui/icons-material';
import '../PrimeFigma/Components/Invoice.css';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import DoneIcon from '@mui/icons-material/Done';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { MoneyFormat, MoneyFormatv3, NewMoneyFormatv2 } from '../../library/MoneyFormat';
import { API, graphqlOperation } from 'aws-amplify';
import CloseIcon from '@mui/icons-material/Close';
import { cancelTransactionMaster } from '../../graphql/mutations';
import {
  getAccountBalance,
  getFinancialYear,
  listGeneralSettingDateWise,
  listVoucherSerialNumbers,
  listaccountbalances,
  listspecificaccountbalance,
  createTransactionWithSpecificTime,
  deleteTransactionMaster,
  listGeneralSetting,
  getMinMaxInvoiceDate,
  createTransactionWithSpecificTimev2,
} from '../../graphql';
import ConfirmCancel from '../../components/modals/confirmCancel';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import DeleteJournalEntries from '../../components/modals/DeleteJournalEntries';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { getTransactionMasterManualJournal, listTransactionManualJournalWithVoucher } from '../../graphql';
import { grey } from '@mui/material/colors';
import AddAccountModal from '../PrimeFigma/Modals/AddAccountModal';
import { uploadToServer } from '../../library/upload';
import { makeStyles, styled } from '@mui/styles';
import Attachment from './AddCustomer/attachment';
import theme from '../../styles/Themecolors';
import { object } from 'yup';
import DraggableAction from '../../components/Buttons/DraggableAction';
import DeleteJournalEntry from '../../components/modals/DeleteJournalEntry';
import InvoiceCancel from '../../components/modals/InvoiceCancel';
import { handleFreeze } from '../../utils/common';
import ConfirmExit from '../../components/modals/ConfirmExit';
import useSaveShortcut from '../../hooks/useSaveShortcut';
import { setNavigationBlocked } from '../../redux/reducers/controllNavigation';
import { listAccountMasterv2Custom } from '../../graphql';
import { useListAccountMasterv2Query } from '../../redux/apis/accountMaster.api';
import NewVoucherSettingsModal from '../PrimeFigma/Modals/newVoucherSettingModal';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import moment from 'moment';
import API_ENDPOINTS from '../../apiEndpoints';
import { useThemes } from '../../components/Theme/theme';
import CustomTooltip from '../../components/CustomTooltip';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import { updateTitle } from '../../redux/reducers/titleSlice';
import CancelUI from '../../components/Ui/CancelUI';
import { useListGeneralSettingQuery, useListVoucherSerialNumbersQuery } from '../../redux/apis/newVoucherSettings.api';
import { CheckVoucherValid } from '../PrimeFigma/Components/CheckVoucherValid';
import { useListCompanyPreferenceQuery } from '../../redux/apis/companyPreference.api';
const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      borderCollapse: 'separate',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  newTableCell: {
    '& .MuiTableCell-root': {
      borderCollapse: 'separate',
      border: '2px solid #9b6ab7 ',
    },
  },
  focusTableCell: {
    // "&:focus-within": {
    //   borderCollapse: "separate",
    //   borderTop: "5px solid  #1d79ff  !important", // Top border
    //   borderBottom: "5px solid  #1d79ff  !important", // Bottom border
    //   borderLeft: "5px solid  #1d79ff  !important", // Left border
    //   borderRight: "5px solid  #1d79ff  !important", // Right border
    // },
    // backgroundColor: "#FFFF99"
  },
  stickyRow: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
});

const headCell = [
  {
    id: 'selectaccount',
    label: 'Select Account',
    width: '300px',
    align: 'left',
    required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
  },
  {
    id: 'currentbalance',
    label: 'Current Balance',
    width: '200px',
    align: 'right',
    rquired: '',
  },
  {
    id: 'debit',
    label: 'Debit',
    width: '200px',
    align: 'right',
    required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
  },
  {
    id: 'credit',
    label: 'Credit',
    width: '200px',
    align: 'right',
    required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
  },
  {
    id: 'description',
    label: 'Description',
    width: '300px',
    align: 'left',
  },
  // {
  //   id: 'link',
  //   label: 'Link',
  //   align: 'left',
  //   width: '300px',
  // },
  {
    id: 'action',
    label: 'Action',
    align: 'center',
    width: '100px',
  },
];

let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;

function CreateManualJournal({ modalEvent, handleClose, accountDetails }) {
  // const navigate = useNavigate();
  const navigate = useControlledNavigation();
  const dispatch = useDispatch();
  const [addEvent, setAddEvent] = useState(false);
  dispatch(display());
  const userPreferenceAndFY = useSelector((state) => state.userPrefrenceandReducer);
  const fyStartDate = moment(userPreferenceAndFY.financialYear.startdate * 1000).format('YYYY-MM-DD');

  const fyEndDate = moment(userPreferenceAndFY.financialYear.enddate * 1000).format('YYYY-MM-DD');

  const { data: companyPreference } = useListCompanyPreferenceQuery();
  const postingDatePref = companyPreference?.find(
    (p) =>
      p.attributetypecd === 'MyPostingDate' &&
      String(p?.additionalvalue ?? '') === String(userPreferenceAndFY?.financialYear?.financialyearid ?? '')
  );
  const savedPostingDate = postingDatePref?.attributevalue;
  const classes = useStyles();
  let location = useLocation();
  const params = location.state || {
    id: parseInt(new URLSearchParams(window.location.search).get('transaction')),
    view: parseInt(new URLSearchParams(window.location.search).get('transaction')) ? true : false,
  };

  let i = 1;
  let totalCredit = 0;
  let totalDebit = 0;

  const { data: generalSettings } = useListGeneralSettingQuery(
    {
      entrytypecd: 'Journal',
      financialyearid: userPreferenceAndFY?.financialYear?.financialyearid,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const voucherFlag = generalSettings?.find((item) => item.expiredtimestamp === 0)?.nextinvoicenumber;
  const newObj = {
    ledgerAccount: { label: '', value: '', AccountGroupID: '' },
    currentBalance: 0,
    description: '',
    credit: 0,
    debit: 0,
    timeStamp: '',
    editable: true,
    new: true,
    order: 1,
    rowsNumber: 2,
  };
  const {
    data: voucherList,
    isLoading: isVoucherListLoading,
    isError: isVoucherListError,
    // refetch
  } = useListVoucherSerialNumbersQuery({
    entrytypecd: 'Journal',
  });
  const [initialState, setInitialState] = useState([newObj, newObj]);
  const [Rows, setRows] = useState(initialState);
  const [updatetedTableRow, setUpdatedTableRow] = useState([]);
  const [currentDouments, setCurrentDocuments] = useState([]);

  const [lastInvoiceDate, setLastInvoiceDate] = useState('');
  const [firstInvoiceDate, setFirstInvoiceDate] = useState('');
  const [nextInvoiceDate, setNextInvoiceDate] = useState('');

  const [focusedField, setFocusedField] = useState(null);

  const getDisplayValue = (value, fieldId) => {
    if (!value) return '';
    if (focusedField === fieldId) {
      return value;
    }
    return MoneyFormatv3(value);
  };

  const [RowsOne, setRowsOne] = useState([
    {
      ledgerAccount: { label: '', value: '', AccountGroupID: '' },
      currentBalance: 0,
      description: '',
      credit: 0,
      debit: 0,
      timeStamp: '',
      editable: true,
      new: true,
      order: 1,
      rowsNumber: 1,
    },
  ]);
  const [editedRow, setEditedRow] = useState({
    ledgerAccount: { label: '', value: '', AccountGroupID: '' },
    currentBalance: 0,
    description: '',
    credit: 0,
    debit: 0,
    timeStamp: '',
    editable: true,
    new: true,
    order: 1,
  });

  const [editedRowOne, setEditedRowOne] = useState({
    ledgerAccount: { label: '', value: '', AccountGroupID: '' },
    currentBalance: 0,
    description: '',
    credit: 0,
    debit: 0,
    timeStamp: '',
    editable: true,
    new: true,
    order: 1,
  });

  const [tempRow, setTempRow] = useState({
    ledgerAccount: { label: '', value: '', AccountGroupID: '' },
    currentBalance: 0,
    description: '',
    credit: 0,
    debit: 0,
    timeStamp: '',
    editable: true,
    new: true,
    order: 1,
  });
  const [tempRowOne, setTempRowOne] = useState({
    ledgerAccount: { label: '', value: '', AccountGroupID: '' },
    currentBalance: 0,
    description: '',
    credit: 0,
    debit: 0,
    timeStamp: '',
    editable: true,
    new: true,
    order: 1,
  });
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [companyDetails, setCOmpanyDetails] = useState('');
  const [deleteEntriesModal, setDeleteEntriesModal] = useState(false);
  const [itemData, setItemData] = useState({});
  const [deleteItemModal, setDeleteItemModal] = useState(false);
  const [state, setState] = useState({
    reason: '',
    errorFields: {
      reason: '',
    },
    errorStatus: {
      reason: false,
    },
  });
  const [cancelModalStatus, setCancelModalStatus] = useState(false);
  const [entryInd, setEntryInd] = useState('');
  const [cancelModal, setCancelModal] = useState(false);
  const [accName, setAccName] = useState([]);
  const [itemsRows, setItemsRows] = useState([
    // { slNo: '', name: '', action: '' }
  ]);
  const [toAccountModal, setToAccountModal] = useState(false);
  const [rowOneAccModalOpen, setRowOneAccModalOpen] = useState(false);
  const [transID, setTransID] = useState('');
  const [accountRowOneBalance, setAccountRowOneBalance] = useState(0);
  const [accountRowTwoBalance, setAccountRowTwoBalance] = useState(0);
  const [accountBalance, setAccountBalance] = useState([]);
  const [rowsOneInd, setRowsOneInd] = useState('');
  const [rowsInd, setRowsInd] = useState('');
  const [rowsNo, setRowsNo] = useState(0);
  const [generalSettingsFlag, setGeneralSettingsFlag] = useState(-1);
  const [settingsModal, setSettingsModal] = useState(false);
  const [journalVoucherNo, setJournalVoucherNo] = useState([]);
  const [entryData, setEntryData] = useState([]);
  const [transArr, setTransArr] = useState([]);
  const [totDbtAmt, setTotDbtAmt] = useState(0);
  const [totCdtAmt, setTotCdtAmt] = useState(0);
  const [totDiffAmt, setTotDiffAmt] = useState(0);
  const [addAccountEvent, setAddAccountEvent] = useState(false);
  const [allAccounts, setAllAccounts] = useState([]);
  const [focusEf, setFocusEf] = useState('');
  const [focusCell, setFocusCell] = useState('');
  const [tableErrArr, setTableErrArr] = useState([]);
  const [initialState1, setInitialState1] = useState({
    vouchernumber: '',
    // date: moment(todayDate).isBetween(fyStartDate, fyEndDate, undefined, '[]') ? todayDate : fyStartDate,
    date: '',
    remarks: '',
    seriesVouchers: { label: '', value: '' },
    errorStatus: {
      vouchernumber: false,
      date: false,
      remarks: false,
      seriesVouchers: false,
    },
    errorFields: {
      vouchernumber: '',
      date: '',
      remarks: '',
      seriesVouchers: '',
    },
  });
  const [data, setData] = useState({ ...initialState1 });
  const [viewMode, setViewMode] = useState(false);
  const [companyFinYrStartDate, setCompanyFinYrStartDate] = useState('');
  const [companyFinYrEndDate, setCompanyFinYrEndDate] = useState('');
  const [clickedButton, setClickedButton] = useState(false);
  const [serialNos, setSerialNos] = useState([]);
  const [activeVouchers, setActiveVouchers] = useState([]);
  const [rowsOneName, setRowsOneName] = useState('');
  const [newPartyID, setNewPartyID] = useState('');
  const [newPartyName, setNewPartyName] = useState('');
  const [selelctedGroupId, setSelectedGroupId] = useState('');
  const [rowOneValidStatus, setRowOneValidStatus] = useState(true);
  const [rowValidStatus, setRowValidStatus] = useState(true);
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/`;
  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  async function formatNumbers(index, value, checkedValue) {
    let updatedTableArr = [...Rows];

    updatedTableArr[index] = {
      ...updatedTableArr[index],
      [value]: (() => {
        let formattedValue = checkedValue;

        if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) {
          formattedValue = '0';
        }

        if (!isNaN(parseFloat(formattedValue))) {
          formattedValue = parseFloat(formattedValue).toFixed(2);
        }
        formattedValue = formattedValue == 0 ? '' : formattedValue;
        return formattedValue;
      })(),
    };

    setRows(updatedTableArr);
  }
  console.log('acc', accName);

  //-----cancel function-----
  const cancel = async (id, type, voucherNo) => {
    const comments = data?.remarks?.split('\n');

    let masterArr = [];

    let journalTransArr = [];

    const updatedTableRow = [...Rows];
    return new Promise(async (resolve, reject) => {
      try {
        const entryData = {
          bankreferencenumber: String(10),
          comments: comments?.join('**'),
          entrydate: Math.floor(new Date(data.date).getTime() / 1000),
          vouchercode: data.vouchernumber,
          serialnumber: generalSettingsFlag == -1 ? '' : data?.seriesVouchers?.value,
          transactionid: Number(transID),
          transactiontypecd: 'ManualJournal',
          cancelflag: 1,
          pdflink: '',
          towards: '',
        };
        masterArr.push(entryData);
        let obj = {};
        updatedTableRow
          ?.sort((p1, p2) => (p1.order > p2.order ? 1 : p1.order < p2.order ? -1 : 0))
          .map((ele, ind) => {
            if (ele.ledgerAccount.value !== '') {
              const comments = ele.description.split('\n');
              obj = {
                accountid: ele.ledgerAccount.value,
                comments: comments?.join('**'),
                creditamount: ele.credit == '' ? 0 : Number(ele.credit),
                debitamount: ele.debit == '' ? 0 : Number(ele.debit),
                // entryordernumber: ind + 1,
                transactionid: transID,
                enteredtimestamp: Math.floor(new Date(data.date).getTime() / 1000),
                transactiontypecd: ele?.debit == '' ? 'Credit' : 'Debit',
                cancelflag: 1,
              };

              journalTransArr.push(obj);
            }
          });
        const result = await API.graphql(
          graphqlOperation(createTransactionWithSpecificTimev2, {
            createTransactionWithSpecificTimeInput: {
              transactionmaster: masterArr,
              transactiondetails: journalTransArr,
              transactionattachment: [],
              transactiontdsdetails: [],
              transactionrelation: [],
              mode: 0,
              transactiontcsdetails: [],
            },
          })
        );
        showSuccessSnackbar('Journal Entry Cancelled');
        handleNavigationBlocker(false);

        navigate('/journalentries', { force: true });
      } catch (error) {
        console.log(error);
        showErrorSnackbar('Something Went Wrong 123!');
      } finally {
        resolve();
      }
    });
  };
  const { theme } = useThemes();
  //-----delete function-----
  async function deleteEntry(data) {
    try {
      const res = await API.graphql(graphqlOperation(deleteTransactionMaster, { transactionid: params?.id }));
      if (res.data?.deleteTransactionMaster != null) {
        handleNavigationBlocker(false);
        navigate('/journalentries', { force: true });
        showSuccessSnackbar('Journal Entry Deleted Successfully ');
      } else {
        showWarningSnackbar('Entry not Deleted.! something went wrong. please try again');
      }
      setBackdropOpen(false);
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  }
  //--------------------
  // ---------leave page-------------
  const [reNavigate, setReNavigate] = useState('');

  function deepEqual(obj1, obj2) {
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return obj1 == obj2;
    }

    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        console.log(key, obj1[key], '//', obj2[key]);
        return false;
      }
    }

    return true;
  }

  async function getLatestJournalDate() {
    try {
      const res = await API.graphql(
        graphqlOperation(getMinMaxInvoiceDate, {
          serialnumber: '',
          invoicetypecd: 'Journal',
          invoiceid: params?.id && !isNaN(params?.id) ? params.id : 0,
        })
      );

      const openingBalanceDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate ?? null;

      setFirstInvoiceDate(openingBalanceDate);
      const date = savedPostingDate ? moment(savedPostingDate * 1000).format('YYYY-MM-DD') : openingBalanceDate;

      setData((prev) => ({ ...prev, date }));
      setInitialState1((prev) => ({ ...prev, date }));
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }

  const [aTags, setATags] = useState(document.getElementsByTagName('a').length);
  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer?.settings);
  useEffect(() => {
    setATags(document.getElementsByTagName('a').length);
    if (selectorDrawer == true) {
      setTimeout(() => {
        setATags(document.getElementsByTagName('a').length);
      }, 50);
    }
  }, [selectorDrawer, selector]);

  const handleNavigationBlocker = (value) => {
    dispatch(setNavigationBlocked(value));
  };

  // useEffect(() => {
  //   if (
  //     !deepEqual(data, initialState1) ||
  //     !deepEqual(RowsOne, initialState) ||
  //     !deepEqual(Rows, initialState) ||
  //     !deepEqual(editedRow, initialState) ||
  //     !deepEqual(editedRowOne, initialState)
  //   ) {
  //     handleNavigationBlocker(true);
  //   }
  //   return () => {
  //     handleNavigationBlocker(false);
  //   };
  // }, [data, aTags]);
  useEffect(() => {
    const isDataChanged = !deepEqual(data, initialState1);
    const isRowsChanged = !deepEqual(Rows, initialState);

    if (isDataChanged || isRowsChanged) {
      handleNavigationBlocker(true);
    }
    if (data?.vouchernumber) {
      dispatch(updateTitle(data.vouchernumber));
    }
    return () => {
      handleNavigationBlocker(false);
    };
  }, [data, Rows, initialState1, initialState]);

  let [modalOpen, setModalOpen] = useState(false);
  // -------------------
  useEffect(() => {
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    }
  }, []);
  const moveCursorToEnd = (event) => {
    event.target.focus();
    event.target.setSelectionRange(event.target.value.length, event.target.value.length);
  };
  const updateAttachmentName = (id, newName) => {
    setItemsRows(itemsRows.map((attachment) => (attachment.attachmentid === id ? { ...attachment, documentname: newName } : attachment)));
  };
  const handleFileChange = (event) => {
    const files = event.target.files;
    const allowedTypes = [
      'application/msword',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'image/jpeg',
      'image/jpg',
      'image/png',
    ];

    let allFilesValid = true;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!allowedTypes.includes(file.type)) {
        showWarningSnackbar('This format is not allowed');
        allFilesValid = false;
        break;
      }
    }

    if (allFilesValid) {
      setItemsRows((currentAttachments) => {
        if (itemsRows.length + files.length > 6) {
          showWarningSnackbar('You cannot add more than 6 attachments');
          return currentAttachments;
        }

        const newAttachments = Array.from(files).map((file) => ({
          attachmentid: currentAttachments.attachmentid ? currentAttachments.attachmentid : Date.now() + file.name,
          imagename: currentAttachments.imagename ? currentAttachments.imagename : path + 'Journal/${id}/LedgerX_' + Date.now() + file.name,
          documentname: file.name,
          type: currentAttachments.type ? currentAttachments.type : file.type,
          imageurl: currentAttachments.imageurl ? currentAttachments.imageurl : URL.createObjectURL(file),
          file,
        }));

        const filteredNewAttachments = newAttachments.filter(
          (newAttachment) => !currentAttachments.some((attachment) => attachment.documentname === newAttachment.documentname)
        );

        return [...currentAttachments, ...filteredNewAttachments];
      });
    } else {
      // Optionally clear the file input if invalid file detected
      event.target.value = ''; // This resets the file input
    }

    // if (imageRef.current) {
    //   imageRef.current.value = "";
    // }
  };

  const inActiveAccount = (accounts) => {
    let temp = [];
    accounts.map((element) => {
      if (!accName.find((ele) => ele.value == element)) {
        temp = [...temp, allAccounts.find((ele) => ele.value == element)];
      }
    });
    temp = [...accName, ...temp];
    temp = temp.filter((element) => element != undefined);
  };
  async function getEntryData(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(getTransactionMasterManualJournal, {
          transactionid: data,
        })
      );
      let inActive = [...res.data?.getTransactionMaster?.[0]?.relatedtransactiondetails.map((element) => element.accountid)];
      inActiveAccount(inActive);

      if (res.data?.getTransactionMaster?.[0] !== null) {
        setEntryData(res.data.getTransactionMaster?.[0]);
        setTransArr(res.data?.getTransactionMaster?.[0]?.relatedtransactiondetails);
        setTransID(res.data.getTransactionMaster?.[0]?.transactionid);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  async function displayJournalDetails(entryData) {
    setBackdropOpen(true);
    let from = new Date(Number(entryData?.entrydate) * 1000);
    let fromyy = from.getFullYear();
    let frommm = from.getMonth() + 1;
    let fromdd = from.getDate();

    if (fromdd < 10) fromdd = '0' + fromdd;
    if (frommm < 10) frommm = '0' + frommm;

    const fromDate = fromyy + '-' + frommm + '-' + fromdd;
    let remark = '';
    remark = entryData?.comments?.split('**');
    if (entryData?.serialnumber === '') {
      setGeneralSettingsFlag(-1);
    } else {
      setGeneralSettingsFlag('');
    }
    setData((prev) => ({
      ...prev,
      vouchernumber: entryData?.vouchernumber,
      seriesVouchers: {
        label: entryData?.vouchernumber,
        value: entryData?.serialnumber,
      },
      date: fromDate,
      remarks: remark?.join('\n'),
    }));
    setInitialState1((prev) => ({
      ...prev,
      vouchernumber: entryData?.vouchernumber,
      seriesVouchers: {
        label: entryData?.vouchernumber,
        value: entryData?.serialnumber,
      },
      date: fromDate,
      remarks: remark?.join('\n'),
    }));
    let selectAcc = { label: '', value: '' };

    if (entryData?.relatedtransactiondetails.length > 0) {
      let arr = [];
      const accArr = entryData.relatedtransactiondetails.map((ele) => ele.accountid);
      let sortedDetails = entryData.relatedtransactiondetails.sort((p1, p2) => p1.entryordernumber - p2.entryordernumber);

      const res = await API.graphql(
        graphqlOperation(listspecificaccountbalance, {
          accountid: accArr?.join(','),
        })
      );
      let updatedSortedDetails = sortedDetails.map((ele) => {
        res.data.listspecificaccountbalance.map((subele) => {
          if (ele.accountid === subele.accountid) {
            ele.currentBal = subele.actualbalance;
          }
        });
        return ele;
      });
      await Promise.all(updatedSortedDetails);

      updatedSortedDetails
        ?.sort((p1, p2) => (p1.entryordernumber > p2.entryordernumber ? 1 : p1.entryordernumber < p2.entryordernumber ? -1 : 0))
        .map(async (ele, ind) => {
          allAccounts?.map((subEle) => {
            if (ele.accountid == subEle.value) {
              selectAcc = {
                label: subEle.label,
                value: subEle.value,
                AccountGroupID: subEle.accountgroupid,
              };
            }
          });
          let comments = '';
          comments = ele?.comments?.split('**');
          arr.push({
            ledgerAccount: selectAcc,
            currentBalance: ele?.currentBal,
            description: comments?.join('\n'),
            credit: ele.creditamount ? parseFloat(ele.creditamount).toFixed(2) : 0,
            debit: ele?.debitamount ? parseFloat(ele.debitamount).toFixed(2) : 0,
            timeStamp: ele.enteredtimestamp,
            editable: false,
            new: false,
            order: ind + 1,
          });
        });
      let totalCredit = 0;
      let totalDebit = 0;
      arr?.sort((a, b) => b.debit - a.debit || b.credit - a.credit);
      arr.map((ele) => {
        if (ele.credit !== '' || ele.debit !== '') {
          totalDebit += Number(ele.debit);
          totalCredit += Number(ele.credit);
        }
      });
      setTotCdtAmt(Number(totalCredit));
      setTotDbtAmt(Number(totalDebit));
      setTotDiffAmt(Number(totalDebit) - Number(totalCredit));
      if (totalDebit > totalCredit) {
        setTotDiffAmt(Number(totalDebit) - Number(totalCredit));
      } else {
        setTotDiffAmt(Number(totalCredit) - Number(totalDebit));
      }
      if (!params?.view) {
        setRows([...arr, newObj]);
        setInitialState([...arr, newObj]);
      } else {
        setRows(arr);
        setInitialState(arr);
      }
    }

    if (entryData.relatedtransactionattachment.length > 0) {
      let items = [];
      entryData.relatedtransactionattachment.map((item, ind) => {
        items.push({
          attachmentid: item.attachmentid,
          documentname: item.documentname,
          imagename: item.attachmentname,

          action: '',
          imageurl: item.attachmenturl,
          type: item.type,
        });
      });
      setItemsRows(items);
      setCurrentDocuments(items);
    }
    setBackdropOpen(false);
  }
  useEffect(() => {
    if (Object.keys(entryData).length > 0) {
      displayJournalDetails(entryData);
    }
  }, [entryData]);
  async function displayRowOneBalance(id, ind, transArr) {
    try {
      if (id) {
        const updatedTableRow = [...Rows];
        const res = await API.graphql(graphqlOperation(getAccountBalance, { accountid: id }));
        if (res.data.getAccountBalance.length > 0) {
          let balance = 0;
          let totCredit = 0;
          let totDebit = 0;
          let currentTotDebit = 0;
          let currentTotCredit = 0;
          if (transArr?.length > 0) {
            transArr?.map((ele) => {
              if (id == ele.accountid) {
                currentTotDebit = +Number(ele.debitamount);
                currentTotCredit = +Number(ele.creditamount);
              }
            });
          }
          updatedTableRow.map((ele) => {
            if (ele.ledgerAccount.value == id) {
              totCredit += Number(ele.credit);
              totDebit += Number(ele.debit);
            }
          });
          totDebit = Number(totDebit) > Number(currentTotDebit) ? Number(totDebit - currentTotDebit) : Number(currentTotDebit - totDebit);
          totCredit =
            Number(totCredit) > Number(currentTotCredit) ? Number(totCredit - currentTotCredit) : Number(currentTotCredit - totCredit);
          balance = Number(res?.data?.getAccountBalance[0]?.actualbalance) + Number(totCredit) - Number(totDebit);
          setAccountRowOneBalance(balance);
          updatedTableRow[ind] = {
            ...updatedTableRow[ind],
            currentBalance: balance ?? 0,
          };
          setRows(updatedTableRow);
        } else {
          setAccountRowOneBalance(0);
        }
      } else {
        setAccountRowOneBalance(0);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function displayRowTwoBalance(id, ind, rowsArr, transArr) {
    try {
      if (id) {
        const res = await API.graphql(graphqlOperation(getAccountBalance, { accountid: id }));
        if (res.data.getAccountBalance.length > 0) {
          let balance = 0;
          let totCredit = 0;
          let totDebit = 0;
          let currentTotDebit = 0;
          let currentTotCredit = 0;
          if (transArr?.length > 0) {
            transArr?.map((ele) => {
              if (id == ele.accountid) {
                currentTotDebit = +Number(ele.debitamount);
                currentTotCredit = +Number(ele.creditamount);
              }
            });
          }
          rowsArr?.map((ele) => {
            if (ele.ledgerAccount.value == id) {
              totCredit += Number(ele.credit);
              totDebit += Number(ele.debit);
            }
          });
          totDebit = Number(totDebit) > Number(currentTotDebit) ? Number(totDebit - currentTotDebit) : Number(currentTotDebit - totDebit);
          totCredit =
            Number(totCredit) > Number(currentTotCredit) ? Number(totCredit - currentTotCredit) : Number(currentTotCredit - totCredit);

          balance = Number(res?.data?.getAccountBalance[0]?.actualbalance) + Number(totCredit) - Number(totDebit);

          setAccountRowTwoBalance(balance);
          rowsArr[ind] = {
            ...rowsArr[ind],
            currentBalance: balance ?? 0,
          };
          setRows(rowsArr);
        } else {
          setAccountRowTwoBalance(0);
        }
      } else {
        setAccountRowTwoBalance(0);
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function getFY() {
    try {
      setStartDate(userPreferenceAndFY.financialYear.startdate);
      setEndDate(userPreferenceAndFY.financialYear.enddate);
    } catch (error) {
      console.log('Error', error);
    }
  }
  // async function getItemSettings() {
  //   try {
  //     setBackdropOpen(true);
  //     let serialNoArr = [];
  //     let voucherNo = '';
  //     let nextInvNo = '';
  //     // const res = await API.graphql(
  //     //   graphqlOperation(listGeneralSettingDateWise, {
  //     //     entrytypecd: "Journal",
  //     //     inputdate: Math.floor(new Date(todayDate).getTime() / 1000),
  //     //   })
  //     // );
  //     const resSerialVouchers = await API.graphql(
  //       graphqlOperation(listGeneralSetting, {
  //         entrytypecd: 'Journal',
  //         financialyearid: getCompany.financialyearid,
  //       })
  //     );

  //     if (resSerialVouchers.data.listGeneralSetting.length > 0) {
  //       let settingsArr = resSerialVouchers.data.listGeneralSetting?.map((ele) => {
  //         if (ele.expiredtimestamp == 0) {
  //           nextInvNo = ele.nextinvoicenumber;
  //           return ele;
  //         }
  //       });
  //       if (nextInvNo !== -1) {
  //         let activeVouchers = resSerialVouchers.data?.listGeneralSetting?.filter((voucher) => voucher.serialisactive == 1);

  //         setActiveVouchers(activeVouchers);
  //         activeVouchers.map((ele) => {
  //           serialNoArr.push({
  //             label: ele.prefix + ele.nextinvoicenumber + ele.suffix,
  //             value: ele.serialnumber,
  //           });
  //           if (ele.serialnumber === serialNoArr?.[0]?.value) {
  //             voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
  //           }
  //         });
  //         setSerialNos(serialNoArr);
  //         if (!params?.id) {
  //           setGeneralSettingsFlag(nextInvNo);
  //           setData((prev) => ({
  //             ...prev,
  //             vouchernumber: voucherNo,
  //             errorStatus: {
  //               ...prev.errorStatus,
  //               vouchernumber: false,
  //             },
  //             errorFields: {
  //               ...prev.errorFields,
  //               vouchernumber: '',
  //             },
  //           }));
  //           setInitialState1((prev) => ({
  //             ...prev,
  //             vouchernumber: voucherNo,
  //             errorStatus: {
  //               ...prev.errorStatus,
  //               vouchernumber: false,
  //             },
  //             errorFields: {
  //               ...prev.errorFields,
  //               vouchernumber: '',
  //             },
  //           }));
  //         }
  //         setData((prev) => ({
  //           ...prev,
  //           seriesVouchers: {
  //             label: serialNoArr?.[0]?.label,
  //             value: serialNoArr?.[0]?.value,
  //           },
  //           errorStatus: {
  //             ...prev.errorStatus,
  //             seriesVouchers: false,
  //           },
  //           errorFields: {
  //             ...prev.errorFields,
  //             seriesVouchers: '',
  //           },
  //         }));
  //         setInitialState1((prev) => ({
  //           ...prev,
  //           seriesVouchers: {
  //             label: serialNoArr?.[0]?.label,
  //             value: serialNoArr?.[0]?.value,
  //           },
  //           errorStatus: {
  //             ...prev.errorStatus,
  //             seriesVouchers: false,
  //           },
  //           errorFields: {
  //             ...prev.errorFields,
  //             seriesVouchers: '',
  //           },
  //         }));
  //       } else {
  //         if (entryData.length == 0) {
  //           setGeneralSettingsFlag(-1);
  //           setData((prev) => ({
  //             ...prev,
  //             vouchernumber: '',
  //             errorStatus: {
  //               ...prev.errorStatus,
  //               vouchernumber: false,
  //             },
  //             errorFields: {
  //               ...prev.errorFields,
  //               vouchernumber: '',
  //             },
  //           }));
  //           setInitialState1((prev) => ({
  //             ...prev,
  //             vouchernumber: '',
  //             errorStatus: {
  //               ...prev.errorStatus,
  //               vouchernumber: false,
  //             },
  //             errorFields: {
  //               ...prev.errorFields,
  //               vouchernumber: '',
  //             },
  //           }));
  //         } else {
  //           setData((prev) => ({
  //             ...prev,
  //             vouchernumber: entryData.vouchernumber,
  //             errorStatus: {
  //               ...prev.errorStatus,
  //               vouchernumber: false,
  //             },
  //             errorFields: {
  //               ...prev.errorFields,
  //               vouchernumber: '',
  //             },
  //           }));
  //           setInitialState1((prev) => ({
  //             ...prev,
  //             vouchernumber: entryData.vouchernumber,
  //             errorStatus: {
  //               ...prev.errorStatus,
  //               vouchernumber: false,
  //             },
  //             errorFields: {
  //               ...prev.errorFields,
  //               vouchernumber: '',
  //             },
  //           }));
  //         }
  //       }
  //     }
  //     setBackdropOpen(false);
  //   } catch (error) {
  //     setBackdropOpen(false);
  //     console.log('error', error);
  //   }
  // }
  //   async function getItemSettings() {
  //   try {
  //     setBackdropOpen(true);

  //     const resSerialVouchers = await API.graphql(
  //       graphqlOperation(listGeneralSetting, {
  //         entrytypecd: "Journal",
  //         financialyearid: getCompany.financialyearid,
  //       })
  //     );

  //     const rows = resSerialVouchers?.data?.listGeneralSetting || [];

  //     if (!rows.length) {
  //       if (!params?.id && (!entryData || entryData.length === 0)) {
  //         const emptySerial = { label: "", value: "" };
  //         setData((p) => ({
  //           ...p,
  //           vouchernumber: "",
  //           seriesVouchers: emptySerial,
  //         }));
  //         setInitialState1((p) => ({
  //           ...p,
  //           vouchernumber: "",
  //           seriesVouchers: emptySerial,
  //         }));
  //       }
  //       setBackdropOpen(false);
  //       return;
  //     }

  //     // ✅ Filter valid & active settings
  //     const validRows = rows.filter((r) => r?.expiredtimestamp === 0);
  //     const activeVouchers = validRows.filter((r) => r?.serialisactive === 1);
  //     setActiveVouchers(activeVouchers);

  //     const nextInvNo = validRows[0]?.nextinvoicenumber ?? -1;
  //     setGeneralSettingsFlag(nextInvNo);

  //     // Helper: prefix + number + suffix
  //     const toLabel = (v) => `${v?.prefix ?? ""}${v?.nextinvoicenumber ?? ""}${v?.suffix ?? ""}`;

  //     let serialNoArr = activeVouchers.map((v) => ({
  //       label: toLabel(v),
  //       value: v?.serialnumber,
  //     }));
  //     setSerialNos(serialNoArr);

  //     let voucherNo = "";
  //     let selectedSeries = serialNoArr[0] || { label: "", value: "" };

  //     // 🔹 Case 1: valid next invoice number → new entry
  //     if (nextInvNo !== -1) {
  //       const firstVoucher = activeVouchers[0];
  //       voucherNo = `${firstVoucher?.prefix ?? ""}${firstVoucher?.nextinvoicenumber ?? ""}${firstVoucher?.suffix ?? ""}`;

  //       if (!params?.id) {
  //         setData((prev) => ({
  //           ...prev,
  //           vouchernumber: voucherNo,
  //           errorStatus: { ...prev.errorStatus, vouchernumber: false },
  //           errorFields: { ...prev.errorFields, vouchernumber: "" },
  //         }));
  //         setInitialState1((prev) => ({
  //           ...prev,
  //           vouchernumber: voucherNo,
  //           errorStatus: { ...prev.errorStatus, vouchernumber: false },
  //           errorFields: { ...prev.errorFields, vouchernumber: "" },
  //         }));
  //       }

  //       setData((prev) => ({
  //         ...prev,
  //         seriesVouchers: selectedSeries,
  //         errorStatus: { ...prev.errorStatus, seriesVouchers: false },
  //         errorFields: { ...prev.errorFields, seriesVouchers: "" },
  //       }));
  //       setInitialState1((prev) => ({
  //         ...prev,
  //         seriesVouchers: selectedSeries,
  //         errorStatus: { ...prev.errorStatus, seriesVouchers: false },
  //         errorFields: { ...prev.errorFields, seriesVouchers: "" },
  //       }));
  //     } else {
  //       // 🔹 Case 2: expired or missing → use entry data or empty
  //       const entryVno =
  //         entryData?.vouchernumber ||
  //         entryData?.invoicenumber ||
  //         entryData?.crdrnotenumber ||
  //         "";

  //       const emptySerial = { label: "", value: "" };

  //       setData((prev) => ({
  //         ...prev,
  //         vouchernumber: entryVno,
  //         seriesVouchers: entryVno ? selectedSeries : emptySerial,
  //         errorStatus: { ...prev.errorStatus, vouchernumber: false },
  //         errorFields: { ...prev.errorFields, vouchernumber: "" },
  //       }));
  //       setInitialState1((prev) => ({
  //         ...prev,
  //         vouchernumber: entryVno,
  //         seriesVouchers: entryVno ? selectedSeries : emptySerial,
  //         errorStatus: { ...prev.errorStatus, vouchernumber: false },
  //         errorFields: { ...prev.errorFields, vouchernumber: "" },
  //       }));
  //     }

  //     setBackdropOpen(false);
  //   } catch (error) {
  //     setBackdropOpen(false);
  //     console.log("getItemSettings error:", error);
  //   }
  // }
  async function getItemSettings() {
    try {
      setBackdropOpen(true);

      const res = await API.graphql(
        graphqlOperation(listGeneralSetting, {
          entrytypecd: 'Journal',
          financialyearid: getCompany.financialyearid,
        })
      );

      const rows = res?.data?.listGeneralSetting || [];
      if (rows.length === 0) {
        const empty = { label: '', value: '' };
        setData((p) => ({ ...p, vouchernumber: '', seriesVouchers: empty }));
        setInitialState1?.((p) => ({ ...p, vouchernumber: '', seriesVouchers: empty }));
        setBackdropOpen(false);
        return;
      }

      const validRows = rows.filter((r) => r?.expiredtimestamp === 0);
      const nextInvNo = validRows[0]?.nextinvoicenumber ?? -1;
      setGeneralSettingsFlag(nextInvNo);

      const activeVouchers = validRows.filter((r) => r?.serialisactive === 1);
      if (activeVouchers.length === 0 && !params?.id) {
        const empty = { label: '', value: '' };
        setData((p) => ({ ...p, vouchernumber: '', seriesVouchers: empty }));
        setInitialState1?.((p) => ({ ...p, vouchernumber: '', seriesVouchers: empty }));
        setBackdropOpen(false);
        return;
      }

      const toLabel = (v) => `${v?.prefix ?? ''}${v?.nextinvoicenumber ?? ''}${v?.suffix ?? ''}`.trim();

      const serialOptions = activeVouchers.map((v) => ({
        label: toLabel(v),
        value: v.serialnumber,
      }));

      setActiveVouchers(activeVouchers);
      setSerialNos(serialOptions);

      const defaultVoucher =activeVouchers.find(v => v.lastused === 1) || activeVouchers[0];
      //  activeVouchers[0];
      const defaultLabel = toLabel(defaultVoucher);
      const selectedOption = { label: defaultLabel, value: defaultVoucher.serialnumber };
      if (params?.id) {
        let editedVoucher = '';
        let editedSeriesVoucher = { label: '', value: '' };
        const editId = entryData?.vouchernumber;
        if (editId) {
          if (entryData?.serialnumber === '') {
            editedVoucher = editId;
            editedSeriesVoucher = { label: '', value: '' };
          } else {
            editedVoucher = editId;
            editedSeriesVoucher = { label: entryData?.vouchernumber, value: entryData?.serialnumber };
          }

          setData((p) => ({
            ...p,
            vouchernumber: editedVoucher !== '' ? editedVoucher : defaultLabel,
            seriesVouchers: editedSeriesVoucher?.value ? editedSeriesVoucher : selectedOption,
          }));
          setInitialState1((p) => ({
            ...p,
            vouchernumber: editedVoucher !== '' ? editedVoucher : defaultLabel,
            seriesVouchers: editedSeriesVoucher.value ? editedSeriesVoucher : selectedOption,
          }));
        }
      } else {
        setData((p) => ({
          ...p,
          vouchernumber: defaultLabel,
          seriesVouchers: selectedOption,
        }));
        setInitialState1?.((p) => ({
          ...p,
          vouchernumber: defaultLabel,
          seriesVouchers: selectedOption,
        }));
      }

      setBackdropOpen(false);
    } catch (error) {
      console.error('getItemSettings error:', error);
      setBackdropOpen(false);
    }
  }

  useEffect(() => {
    getItemSettings();
  }, [voucherList]);
  async function listVoucherNos() {
    try {
      let Arr = [];
      const res = await API.graphql(graphqlOperation(listTransactionManualJournalWithVoucher));
      if (res.data.listTransactionManualJournal.length > 0) {
        res.data.listTransactionManualJournal.map((ele) => {
          if (ele.TransactionTypeCD === 'ManualJournal') {
            Arr.push(ele);
          }
        });
        setJournalVoucherNo(Arr);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  useEffect(() => {
    getFY();
    // listVoucherNos();
    if (params?.id) {
      if (transID) {
        getLatestJournalDate();
      }
    } else {
      getLatestJournalDate();
    }
  }, [savedPostingDate]);
  useEffect(() => {
    if (params?.id) {
      getEntryData(params?.id);
    }
    if (params?.view === true) {
      setViewMode(true);
    } else {
      setViewMode(false);
    }
  }, []);

  async function saveChanges(objFlag) {
    try {
      const { vouchernumber, date, remarks } = data;
      let isvalid = true;
      let errArr = [];
      const formData = { vouchernumber, date, remarks };
      const comments = data.remarks.split('\n');
      let masterArr = [];
      let requireds = [];
      let totalCredit = 0;
      let totalDebit = 0;
      let journalTransArr = [];
      if (formVaidation(formData)) {
        const updatedTableRow = [...Rows];
        const hasValidLedger = updatedTableRow.some((ele) => ele?.ledgerAccount?.label !== '');
        if (updatedTableRow.length > 0) {
          updatedTableRow.map((ele, index) => {
            totalCredit += Number(ele.credit);
            totalDebit += Number(ele.debit);

            if (ele.ledgerAccount.label !== '' || totalDebit !== totalCredit) {
              if (ele?.ledgerAccount?.value == '') {
                errArr.push('ledgerAccount' + index);
                isvalid = false;
                requireds.push('Ledger Account');
              }
              if ((ele?.debit == 0 || ele?.debit === '') && (ele?.credit == 0 || ele?.credit === '')) {
                errArr.push('debit' + index);
                errArr.push('credit' + index);
                requireds.push('Credit/Debit amount');
                isvalid = false;
              }
            }
            return isvalid;
          });
          if (Number(totalCredit) === 0 && Number(totalDebit) === 0 && !hasValidLedger) {
            showWarningSnackbar('Please complete the actions in your entry table');
            return;
          }
          if (Number(totalCredit)?.toFixed(2) !== Number(totalDebit)?.toFixed(2)) {
            showWarningSnackbar('Debit and Credit total of Journal Entry to be equal');
            return;
          }
        } else {
          setRows([newObj, newObj]);
          isvalid = false;
        }

        if (isvalid) {
          setBackdropOpen(true);
          const entryData = {
            bankreferencenumber: String(10),
            comments: comments?.join('**'),
            entrydate: Math.floor(new Date(data.date).getTime() / 1000),
            transactiontypecd: 'ManualJournal',
            vouchercode: data.vouchernumber,
            serialnumber: Number(voucherFlag) === -1 ? '' : data?.seriesVouchers?.value,
            // cancelflag: 0,
            pdflink: '',
            towards: '',
            // cancelremark: ""
          };
          masterArr.push(entryData);
          let obj = {};
          updatedTableRow
            ?.sort((p1, p2) => (p1.order > p2.order ? 1 : p1.order < p2.order ? -1 : 0))
            .map((ele, ind) => {
              if (ele.ledgerAccount.value !== '') {
                obj = {
                  accountid: Number(ele.ledgerAccount.value),
                  comments: ele.description,
                  creditamount: ele.credit == '' ? 0 : Number(ele.credit),
                  debitamount: ele.debit == '' ? 0 : Number(ele.debit),
                  // entryordernumber: ind + 1,

                  transactiontypecd: ele?.debit == '' ? 'Credit' : 'Debit',
                  // cancelflag: 0,
                };

                journalTransArr.push(obj);
              }
            });

          let attachment = itemsRows.map((item) => {
            const attachmentData = {
              // AttachmentID: item?.AttachmentID,
              attachmentname: item.imagename,
              attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${item.imagename}`,
              documentname: item.documentname,
              type: item?.type?.split('/')[1],
            };
            return attachmentData;
          });

          const result = await API.graphql(
            graphqlOperation(createTransactionWithSpecificTimev2, {
              createTransactionWithSpecificTimeInput: {
                transactionmaster: masterArr,
                transactiondetails: journalTransArr,
                transactionattachment: attachment,
                transactiontdsdetails: [],
                transactionrelation: [],
                mode: 1,
                transactiontcsdetails: [],
              },
            })
          );
          console.log(result.data, 'result.data');
          let responses = itemsRows.map((element) => {
            if (element.file) {
              return uploadToServer(
                element.file,
                element.imagename.replace('${id}', result.data.createTransactionWithSpecificTimev2.transactionid),
                element.type
              );
            }
          });
          let response = await Promise.all(responses);
          dispatch(dashboardApi.util.invalidateTags(['dashboard',"bizview"]));
          if (objFlag.new === false) {
            if (modalEvent === true) {
            }
            showSuccessSnackbar('Journal Entry Created Successfully!');
            if (modalEvent === true) {
              handleClose();
            } else {
              navigate('/journalentries', { force: true });
            }
          } else {
            showSuccessSnackbar('Journal Entry Created Successfully!');
            setBackdropOpen(false);
            // window.location.reload();

            setData(initialState1);
            setRows([...initialState]);
            setItemsRows(currentDouments);
            getLatestJournalDate();
            getItemSettings();
            setRowValidStatus(true);
          }
        } else {
          requireds = [...new Set(requireds)];
          if (requireds.length === 1) {
            showWarningSnackbar(`${requireds}` + ' ' + 'is required');
          }
          if (requireds.length > 1) {
            showWarningSnackbar(`${requireds}` + ' ' + 'are required');
          }
          setRowValidStatus(isvalid);
          setTableErrArr(errArr);
        }
      }
      handleNavigationBlocker(false);
    } catch (error) {
      console.log('error', error);
      setBackdropOpen(false);
      const rawMessage = error?.errors[0]?.message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;

      const errorMessage = parsedMessage.replace('Error: ', '').split(',')[0];

      showErrorSnackbar(errorMessage);
    }
  }

  async function saveEditChanges(objFlag) {
    try {
      const { vouchernumber, date, remarks } = data;
      const formData = { vouchernumber, date, remarks };
      const comments = data?.remarks?.split('\n');
      let isvalid = true;
      let errArr = [];
      let masterArr = [];
      let requireds = [];
      let journalTransArr = [];
      let totalCredit = 0;
      let totalDebit = 0;
      if (formVaidation(formData)) {
        const updatedTableRow = [...Rows];
        const hasValidLedger = updatedTableRow.some((ele) => ele?.ledgerAccount?.label !== '');
        if (updatedTableRow.length > 0) {
          updatedTableRow.map((ele, index) => {
            totalCredit += Number(ele.credit);
            totalDebit += Number(ele.debit);
            if (ele.ledgerAccount.label !== '' || Number(totalDebit)?.toFixed(2) !== Number(totalCredit)?.toFixed(2)) {
              if (ele?.ledgerAccount?.value == '') {
                errArr.push('ledgerAccount' + index);
                isvalid = false;
                requireds.push('Ledger Account');
              }
              if ((ele?.debit == 0 || ele?.debit === '') && (ele?.credit == 0 || ele?.credit === '')) {
                errArr.push('debit' + index);
                errArr.push('credit' + index);
                requireds.push('Credit/Debit amount');
                isvalid = false;
              }
            }
            return isvalid;
          });
          if (Number(totalCredit) === 0 && Number(totalDebit) === 0 && !hasValidLedger) {
            showWarningSnackbar('Please complete the actions in your entry table');
            return;
          }
          if (Number(totalCredit)?.toFixed(2) !== Number(totalDebit)?.toFixed(2)) {
            showWarningSnackbar('Debit and Credit total of Journal Entry to be equal');
            return;
          }
        } else {
          setRows([newObj, newObj]);
          isvalid = false;
        }

        setRowValidStatus(isvalid);
        if (isvalid) {
          setBackdropOpen(true);
          const entryData = {
            bankreferencenumber: String(10),
            comments: comments?.join('**'),
            entrydate: Math.floor(new Date(data.date).getTime() / 1000),
            vouchercode: data?.vouchernumber === '' ? String(data.seriesVouchers.label) : String(data?.vouchernumber),
            serialnumber: Number(voucherFlag) === -1 ? '' : data?.seriesVouchers?.value,
            transactionid: transID,
            transactiontypecd: 'ManualJournal',
            cancelflag: 0,
            pdflink: '',
            towards: '',
          };
          masterArr.push(entryData);
          let obj = {};
          updatedTableRow
            ?.sort((p1, p2) => (p1.order > p2.order ? 1 : p1.order < p2.order ? -1 : 0))
            .map((ele, ind) => {
              if (ele.ledgerAccount.value !== '') {
                const comments = ele.description.split('\n');
                obj = {
                  accountid: ele.ledgerAccount.value,
                  comments: comments?.join('**'),
                  creditamount: ele.credit == '' ? 0 : Number(ele.credit),
                  debitamount: ele.debit == '' ? 0 : Number(ele.debit),
                  // entryordernumber: ind + 1,
                  transactionid: transID,
                  enteredtimestamp: Math.floor(new Date(data.date).getTime() / 1000),
                  transactiontypecd: ele?.debit == '' ? 'Credit' : 'Debit',
                  cancelflag: 0,
                };

                journalTransArr.push(obj);
              }
            });
          Math.floor(new Date().getTime() / 1000);
          let attachment = itemsRows.map((item) => {
            const attachmentData = {
              attachmentid: typeof item.attachmentid === 'string' ? 0 : item.attachmentid,
              attachmentname: item.imagename,
              documentname: item.documentname,
              attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${item.imagename}`,
              transactionid: transID,
              type: item?.type,
            };
            return attachmentData;
            // addAttachmets(attachmentData);
          });
          const result = await API.graphql(
            graphqlOperation(createTransactionWithSpecificTimev2, {
              createTransactionWithSpecificTimeInput: {
                transactionmaster: masterArr,
                transactiondetails: journalTransArr,
                transactionattachment: attachment,
                transactiontdsdetails: [],
                transactionrelation: [],
                mode: 0,
                transactiontcsdetails: [],
              },
            })
          );
          console.log(itemsRows, 'itemsRows');
          let responses = itemsRows.map((element) => {
            if (element.file) {
              return uploadToServer(
                element.file,
                element.imagename.replace('${id}', result.data.createTransactionWithSpecificTimev2.transactionid),
                element.type
              );
            }
          });
          let response = await Promise.all(responses);
          localStorage.removeItem('JournalTransactionID');
          localStorage.removeItem('JournalViewMode');
          localStorage.setItem('updateEvent', true);
          if (objFlag.new === false) {
            navigate('/journalentries', { force: true });
            showSuccessSnackbar('Journal Entry Updated Successfully');
          } else {
            showSuccessSnackbar('Journal Entry Updated Successfully');
            window.location.reload();
          }
        } else {
          requireds = [...new Set(requireds)];
          if (requireds.length === 1) {
            showWarningSnackbar(`${requireds}` + ' ' + 'is required');
          }
          if (requireds.length > 1) {
            showWarningSnackbar(`${requireds}` + ' ' + 'are required');
          }
          setRowValidStatus(isvalid);
          setTableErrArr(errArr);
        }
      }
      handleNavigationBlocker(false);
    } catch (error) {
      console.log('error', error);
      setBackdropOpen(false);
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;

      const errorMessage = parsedMessage.replace('Error: ', '').split(',')[0];

      showErrorSnackbar(errorMessage);
    }
  }

  function formVaidation(inputs) {
    let isvalid = true;
    let obj = { ...data };

    Object.keys(inputs).map((itemKey) => {
      if (itemKey === 'date') {
        const startDate = userPreferece.financialYear.startdate * 1000;
        const endDate = userPreferece.financialYear.enddate * 1000;

        const minDate = moment(params?.id && !isNaN(params.id) ? firstInvoiceDate || startDate : lastInvoiceDate || startDate);

        const maxDate = moment(params?.id && !isNaN(params.id) ? nextInvoiceDate || endDate : endDate);

        if (!inputs[itemKey]?.trim()) {
          isvalid = false;
          obj.errorFields.date = 'Please select the Journal Voucher Date';
          obj.errorStatus.date = true;
        } else if (moment(inputs[itemKey], 'YYYY-MM-DD').isBefore(minDate) || moment(inputs[itemKey], 'YYYY-MM-DD').isAfter(maxDate)) {
          isvalid = false;
          obj.errorFields.date = `Entry Date must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format('DD MMM YYYY')}`;
          obj.errorStatus.date = true;
        } else {
          obj.errorFields.date = '';
          obj.errorStatus.date = false;
        }
      }

      if (itemKey === 'vouchernumber') {
        const { valid, message } = CheckVoucherValid(inputs[itemKey], 'Voucher Number');
        if (inputs[itemKey]?.trim().length <= 0) {
          isvalid = false;
          obj.errorFields.vouchernumber = 'Voucher Number is Required';
          obj.errorStatus.vouchernumber = true;
        } else if (!valid) {
          isvalid = false;
          obj.errorFields.vouchernumber = message;
          obj.errorStatus.vouchernumber = true;
        } else {
          let valid = true;
          journalVoucherNo.map((ele) => {
            if (ele.VoucherNumber !== entryData.VoucherNumber) {
              if (ele.VoucherNumber === data.vouchernumber) {
                valid = false;
              }
            }
          });
          if (valid === false) {
            isvalid = false;
            obj.errorFields.vouchernumber = 'Voucher Number already exists';
            obj.errorStatus.vouchernumber = true;
          } else {
            obj.errorFields.vouchernumber = '';
            obj.errorStatus.vouchernumber = false;
          }
        }
      }
      if (itemKey === 'remarks') {
        if (obj[itemKey]?.trim()?.length > 250 && obj[itemKey]?.trim()?.length > 0) {
          isvalid = false;
          obj.errorFields.remarks = 'Description must be less than 250 characters';
          obj.errorStatus.remarks = true;
        } else {
          obj.errorFields.remarks = '';
          obj.errorStatus.remarks = false;
        }
      }
    });

    setData(obj);

    return isvalid;
  }

  function saveChangesInRows(ind) {
    let isvalid = true;
    let errArr = [];
    let requireds = [];
    const updatedTableRow = [...Rows];
    updatedTableRow.map((ele, index) => {
      if (ele?.ledgerAccount?.label === '') {
        requireds.push('Ledger Account');
        errArr.push('ledgerAccount' + index);
        isvalid = false;
      }
      if ((ele?.debit == 0 || ele?.debit === '') && (ele?.credit == 0 || ele?.credit === '')) {
        requireds.push('Credit/Debit amount');

        errArr.push('debit' + index);
        errArr.push('credit' + index);
        isvalid = false;
      }
      return isvalid;
    });
    let elements = document?.getElementById(errArr[0]);
    elements?.focus();
    setRowValidStatus(isvalid);
    setTableErrArr(errArr);
    if (isvalid) {
      let arr = [...updatedTableRow];

      setRows([...arr, newObj]);
      setAddEvent(true);
    } else {
      if (requireds.length === 1) {
        showWarningSnackbar(`${requireds}` + ' ' + 'is required');
      }
      if (requireds.length > 1) {
        showWarningSnackbar(`${requireds}` + ' ' + 'are required');
      }
    }
  }

  function closeChangesInRows(ind) {
    let arr = [...Rows].filter((item, index) => {
      if (ind != index) {
        return item;
      }
    });
    setRows(arr);
  }
  const { data: ledgerList ,isLoading: isLoadingLedgerList} = useListAccountMasterv2Query();
  function comparePathWithId(pathString, ...ids) {
    const pathArray = pathString?.replace(/^\/|\/$/g, '').split('/');
    const pathWithoutAccountId = pathArray?.slice(0, -1);

    return !ids.some((id) => pathWithoutAccountId?.includes(id.toString()));
  }
  async function getAccountMasterData() {
    try {
      // const res = await API.graphql(
      //   graphqlOperation(listAccountMasterv2Custom)
      // );
      let res = { data: { listAccountMasterv2: ledgerList } };

      let allAccount = [];
      let obj = {};
      if (res.data.listAccountMasterv2 !== null) {
        let filteredAllAccArray = res.data.listAccountMasterv2?.filter((item) => comparePathWithId(item.path, 16, 17, 29, 21));
        filteredAllAccArray = filteredAllAccArray.filter((item) => {
          const isExcludedByAccountId =
            item?.accountsid === 12 || (companyType === 1 && (item.accountsid === 32 || item.accountsid === 33));

          const isExcludedByPath = [16, 17, 19, 21].includes(item.path);

          const isExcludedByTaxType = companyType === 1 && [2, 4, 5].includes(item.tax_type);

          return !isExcludedByAccountId && !isExcludedByPath && !isExcludedByTaxType;
        });
        filteredAllAccArray.map((item) => {
          if (item.accountsid !== 24 && item.accountsid !== 23) {
            let groupName = item?.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();

            allAccount.push({
              label: item.accountname,
              value: item.accountsid,
              AccountGroupID: item?.accountgroupid,
              Is_Active: item.is_active,
              groupName,
            });
            obj[item.accountsid] = item.accountname;
          }
        });
        listAccountBalanceOfLedger();
        let GSTArrayValues = [4, 5, 6, 7, 8, 9, 10, 11, 19, 20, 29];
        let setArrayAll =
          getCompany?.relatedcompanydetailsnew.registrationtype !== 1
            ? [...allAccount]
            : allAccount.filter((e) => !GSTArrayValues.includes(e.value));
        setAllAccounts(setArrayAll);
        setAccName(setArrayAll.filter((ele) => ele.Is_Active === 1));
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function listAccountBalanceOfLedger() {
    try {
      let accBalArr = [];
      const res = await API.graphql(graphqlOperation(listaccountbalances));
      if (res.data.listaccountbalances !== null) {
        res.data.listaccountbalances.map((ele) => {
          accBalArr.push({
            label: ele.actualbalance,
            value: ele.accountid,
          });

          setAccountBalance(accBalArr);
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      let promises = [getAccountMasterData()];
      await Promise.all(promises);
    };
    if(!isLoadingLedgerList&&ledgerList?.length){
      fetchData();
  }

  }, [ledgerList]);

  const companyLoaded = useSelector((state) => state?.companyReducer.Loaded);

  async function getCompanyDetails() {
    try {
      let compID = localStorage.getItem('companyID');
      setCOmpanyDetails({ getCompany });
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (companyLoaded) getCompanyDetails();
  }, [companyLoaded]);

  async function listUserPreferenceData() {
    try {
      // const res = await API.graphql(graphqlOperation(listUserPreference));
      // let attributeValue = "";
      // res?.data?.listUserPreference.map((ele) => {
      //   if (ele.AttributeTypeCD == "SelectedFinYear")
      //     attributeValue = ele.AttributeValue;
      // })
    } catch (error) {
      console.log('error', error);
    }
  }

  useEffect(() => {
    listUserPreferenceData();
  }, []);

  function getTotalDebitCreditByCredit(value, index) {
    const updatetedTableRow = [...Rows];
    let totalDebit = 0;
    let totalCredit = 0;
    updatetedTableRow.map((ele) => {
      if (ele.credit !== '' || ele.debit !== '') {
        totalDebit += Number(ele.debit);
        totalCredit += Number(ele.credit);
      }
    });
    totalCredit = Number(totalCredit) + Number(value);
    setTotCdtAmt(Number(totalCredit));
    setTotDbtAmt(Number(totalDebit));
    setTotDiffAmt(Number(totalDebit) - Number(totalCredit));
    if (totalDebit > totalCredit) {
      setTotDiffAmt(Number(totalDebit) - Number(totalCredit));
    } else {
      setTotDiffAmt(Number(totalCredit) - Number(totalDebit));
    }
    updatetedTableRow[index] = {
      ...updatetedTableRow[index],
      credit: value === '' ? 0 : value,
      debit: 0,
    };
    setRows(updatetedTableRow);
  }
  function getTotalDebitCreditByDebit(value, index) {
    const updatedTableRow = [...Rows];
    let totalDebit = 0;
    let totalCredit = 0;
    updatedTableRow.map((ele) => {
      if (ele.credit !== '' || ele.debit !== '') {
        totalDebit += Number(ele.debit);
        totalCredit += Number(ele.credit);
      }
    });
    totalDebit = Number(totalDebit) + Number(value);
    setTotCdtAmt(Number(totalCredit));
    setTotDbtAmt(Number(totalDebit));
    if (totalDebit > totalCredit) {
      setTotDiffAmt(Number(totalDebit) - Number(totalCredit));
    } else {
      setTotDiffAmt(Number(totalCredit) - Number(totalDebit));
    }
    updatedTableRow[index] = {
      ...updatedTableRow[index],
      debit: value === '' ? 0 : value,
      credit: 0,
    };

    setRows(updatedTableRow);
  }

  function dispalyJournalTotalDebitCredit() {
    let totalCredit = 0;
    let totalDebit = 0;

    if (Rows.length > 0) {
      Rows.map((ele) => {
        if (ele.debit !== '' || ele.credit !== '') {
          totalCredit += Number(ele.credit);
          totalDebit += Number(ele.debit);
        }
      });
      setTotCdtAmt(Number(totalCredit));
      setTotDbtAmt(Number(totalDebit));
      if (totalDebit > totalCredit) {
        setTotDiffAmt(Number(totalDebit) - Number(totalCredit));
      } else {
        setTotDiffAmt(Number(totalCredit) - Number(totalDebit));
      }
    } else {
      setTotCdtAmt(0);
      setTotDbtAmt(0);
      setTotDiffAmt(0);
    }
  }
  useEffect(() => {
    dispalyJournalTotalDebitCredit();
  }, [Rows]);
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  useEffect(() => {
    if (tableErrArr.length > 0) {
      let element = document?.getElementById(tableErrArr[0]);
      element?.focus();
    }
  }, [tableErrArr]);
  const ids = [
    'partyCreationModal',
    'addItemModal',
    'deleteCategory',
    'AddLedger',
    'AddHSNModal',
    'AddTdsTcsOptions',
    'BillingAddressModal',
    'DeliveryAddressModal',
    'SettingsModal',
  ];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);
  useSaveShortcut(
    params?.id && params?.view !== true
      ? () => {
          if (!anyElementExists()) saveEditChanges({ new: false });
        }
      : params?.view !== true
      ? () => {
          if (!anyElementExists()) saveChanges({ new: false });
        }
      : undefined
  );
  function handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }
    const minDate = moment(
      params?.id && !isNaN(params.id)
        ? firstInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD')
        : lastInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    const maxDate = moment(
      params?.id && !isNaN(params.id)
        ? nextInvoiceDate || moment(endDate * 1000).format('YYYY-MM-DD')
        : moment(endDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );
    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (required && e.target.value === '') {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: '',
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else if (
        name === 'date' &&
        (moment(e?.target?.value, 'YYYY-MM-DD').isBefore(minDate) || moment(e?.target?.value, 'YYYY-MM-DD').isAfter(maxDate))
      ) {
        e.preventDefault();
        e.stopPropagation();
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  function handleEntryTextKeyDown(e, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (required && (e.target.value === '' || e.target.value == 0)) {
        e.preventDefault();
        e.stopPropagation();
        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  function handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID, multiple) {
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';

    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
      if (multiple && e.key === 'Enter') {
        return; // Exit without moving focus to next field
      }

      if (required && e.target.value === '' && isAutocompleteOpen && !activeDescendantId) {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: '',
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  function handleEntryAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID, multiple) {
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';

    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
      if (multiple && e.key === 'Enter') {
        return; // Exit without moving focus to next field
      }

      if (
        required &&
        (e.target.value === '' || e.target.value === undefined || e.target.value === null) &&
        isAutocompleteOpen &&
        !activeDescendantId
      ) {
        e.preventDefault();
        e.stopPropagation();
        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  useEffect(() => {
    let updateTableRow = [...Rows];
    const zeroItemIndex = updateTableRow.findIndex((row) => row.ledgerAccount?.value === '');
    if (addEvent) {
      const element = document.getElementById(`ledgerAccount${zeroItemIndex}`);
      if (element) {
        element.focus();
      }
      setAddEvent(false);
    }
  }, [addEvent, Rows]);
  useEffect(() => {
    console.log('accountDetails', accountDetails);

    if (accountDetails) {
      const updatedRows = [...Rows];
      updatedRows[0] = {
        ...updatedRows[0],
        ledgerAccount: {
          label: accountDetails?.label,
          value: accountDetails?.accountsid,
        },
      };
      setRows(updatedRows);
    }
  }, [accountDetails]);
  function handleInvoiceDateChanges(value) {
    const minDate = moment(
      params?.id && !isNaN(params.id)
        ? firstInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD')
        : lastInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    const maxDate = moment(
      params?.id && !isNaN(params.id)
        ? nextInvoiceDate || moment(endDate * 1000).format('YYYY-MM-DD')
        : moment(endDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    if (value === '') {
      setData((prev) => ({
        ...prev,
        date: value,
        errorStatus: {
          ...prev.errorStatus,
          date: true,
        },
        errorFields: {
          ...prev.errorFields,
          date: 'Please select Journal Voucher Date',
        },
      }));
      return;
    }

    const momentInvoiceDate = moment(value, 'YYYY-MM-DD');

    // Check if invoiceDate is within the allowed range
    if (momentInvoiceDate.isBefore(minDate) || momentInvoiceDate.isAfter(maxDate)) {
      setData((prev) => ({
        ...prev,
        date: value,
        errorStatus: {
          ...prev.errorStatus,
          date: true,
        },
        errorFields: {
          ...prev.errorFields,
          date: `Entry Date
             must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format('DD MMM YYYY')}.`,
        },
      }));
      return;
    }

    setData((prev) => ({
      ...prev,
      date: value,

      errorStatus: {
        ...prev.errorStatus,
        date: false,
      },
      errorFields: {
        ...prev.errorFields,
        date: '',
      },
    }));
  }
  return (
    <Box className="PageHeight">
      <Box
        className="darkDisabledInputs"
        sx={{
          width: '100%',
          backgroundColor: '',
          // paddingTop: modalEvent == true ? "30px" : "60px",
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: {
              xs: 'none',
              sm: 'flex',
              md: 'flex',
              lg: 'flex',
              xl: 'flex',
            },
            justifyContent: 'space-between',
          }}
        ></Box>

        <Box>
          {viewMode === true && entryData?.cancelflag ? (
            <>
              <Box
                sx={{
                  position: 'sticky',
                  top: '10px',
                  borderRadius: '8px',
                  marginBottom: '0px',
                  padding: { xs: '10px 0px', sm: '10px 10px' },
                  transition: 'all 1s ease-in-out',
                }}
              >
                <Alert
                  variant="standard"
                  sx={{
                    color: entryData?.cancelflag === 0 ? '' : 'red',
                    boxShadow: 'none',
                    width: 450,
                  }}
                  severity="error"
                >
                  {entryData?.cancelflag === 1 ? 'Journal cancelled. No further updates can be made.' : null}
                </Alert>
              </Box>
              <Box sx={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '10' }}>
                <CancelUI />
              </Box>
            </>
          ) : null}
          <Box
            sx={{
              opacity: viewMode === true && entryData?.cancelflag ? '0.5' : '1',
              cursor: viewMode === true && entryData?.cancelflag ? 'no-drop' : 'default',
            }}
          >
            <Box
              sx={{
                borderRadius: '8px',
                // marginBottom: "20px",
                // boxShadow:
                //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                padding: { xs: '10px 0px', sm: '0px 0px' },
                ':hover': {
                  boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
                },
                transition: 'all 1s ease-in-out',
              }}
            >
              <Grid container spacing={2} sx={{ m: 1, width: '100%', marginLeft: '0px' }}>
                <Grid
                  xs={11}
                  md={9}
                  sx={{
                    display: 'flex',
                    // flexDirection: { md: "row", xs: "column" },
                  }}
                >
                  {generalSettingsFlag !== -1 ? (
                    <>
                      <Grid lg={3} md={3} xs={12}>
                        <Autocomplete
                          disablePortal
                          disabled={params?.id
                            
                            // viewMode == true || (entryData?.isvouchereditable === 0 && entryData.serialnumber !== '') ? true : false
                          }
                          id="sereisVouchers"
                          options={params?.id ? serialNos?.filter((r) => r?.value !== entryData?.serialnumber) : serialNos}
                          disableClearable
                          value={data.seriesVouchers}
                          isOptionEqualToValue={(option, value) => option?.value == value?.value}
                          onChange={(e, newValue) => {
                            let voucherNo = '';
                            if (newValue?.value !== '') {
                              activeVouchers.map((ele) => {
                                if (ele.serialnumber === newValue.value) {
                                  voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
                                }
                              });
                              setData((prev) => ({
                                ...prev,
                                seriesVouchers: newValue,
                                vouchernumber: voucherNo,
                              }));
                            }
                          }}
                          onKeyDown={(e) => {
                            const warMsg = 'Voucher Number is required';
                            const name = 'vouchernumber';
                            const currentId = 'sereisVouchers';
                            const nextId = 'yrbook';
                            const prevID = '';
                            const required = true;
                            handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
                          }}
                          sx={{
                            '.css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                              paddingBottom: '5px',
                            },
                            '.css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                              paddingTop: '6px',
                              paddingBottom: '5px',
                              paddingLeft: '6px',
                            },
                          }}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              sx={{
                                '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                                  padding: '8.5px 7px',
                                },
                                '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                                  fontSize: '14px',
                                },
                                label: {
                                  fontSize: '14px',
                                },
                                '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                                  fontSize: '14px',
                                },
                                '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                                  color: 'input.font',
                                },
                                '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'input.border',
                                },
                                '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                                  color: 'input.font',
                                },
                                '.css-14qz1ij-MuiListItemText-root': {
                                  margin: '0px',
                                },
                                '.MuiFormLabel-asterisk': {
                                  color: 'danger.main',
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                },
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Journal Prefix/Suffix"
                              required={data?.seriesVouchers?.value === '' ? true : false}
                            />
                          )}
                        />
                      </Grid>
                    </>
                  ) : (
                    <Grid lg={3} md={3} xs={12}>
                      <TextField
                        error={data.errorStatus.vouchernumber == true ? true : false}
                        name="sereisVouchers"
                        id="sereisVouchers"
                        label="Voucher Number"
                        size="small"
                        type="text"
                        disabled={
                          // viewMode == true 
                          
                          
                         params?.id ? true : false}
                        fullWidth
                        required={data.vouchernumber === '' ? true : false}
                        value={data.vouchernumber}
                        sx={{
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontSize: '16px',
                            fontWeight: 'bold',
                          },
                        }}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const { valid, message } = CheckVoucherValid(value, 'Voucher Number');
                          if (value == '') {
                            setData((prev) => ({
                              ...prev,
                              vouchernumber: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                vouchernumber: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                vouchernumber: 'Voucher Number is requierd',
                              },
                            }));
                          } else if (!valid) {
                            setData((prev) => ({
                              ...prev,
                              vouchernumber: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                vouchernumber: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                vouchernumber: message,
                              },
                            }));
                          } else {
                            let isValid = true;
                            journalVoucherNo?.map((ele) => {
                              if (ele.VoucherNumber !== entryData.VoucherNumber) {
                                if (ele.VoucherNumber === value) {
                                  isValid = false;
                                }
                              }
                            });
                            if (isValid == false) {
                              setData((prev) => ({
                                ...prev,
                                vouchernumber: value,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  vouchernumber: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  vouchernumber: 'Voucher Number already exists',
                                },
                              }));
                            } else {
                              setData((prev) => ({
                                ...prev,
                                vouchernumber: value,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  vouchernumber: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  vouchernumber: '',
                                },
                              }));
                            }
                          }
                        }}
                        onKeyDown={(e) => {
                          const warMsg = 'Voucher Number is required';
                          const name = 'vouchernumber';
                          const currentId = 'sereisVouchers';
                          const nextId = 'yrbook';
                          const prevID = '';
                          const required = true;
                          handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
                        }}
                        InputProps={{
                          inputProps: { maxLength: 16 },
                        }}
                      />
                      <Typography
                        sx={{
                          marginTop: '2px',
                          marginLeft: '10px',
                          marginBottom: '0px',
                          fontSize: '11px',
                          color: 'danger.main',
                        }}
                      >
                        {data?.errorFields.vouchernumber}
                      </Typography>
                    </Grid>
                  )}

                  {(!params?.id &&
                  //  || entryData?.isvouchereditable === 1 || entryData?.serialnumber === '') && (
                    <Button
                      onClick={() => {
                        setSettingsModal(true);
                      }}
                    >
                      <Settings
                        sx={{
                          color: '#b5b5b5',
                          transition: 'transform 0.3s',
                          transform: `rotate(${focusEf === 'settings' ? '75deg' : '0'})`,
                        }}
                      />
                    </Button>
                  )}

                  <Grid xs={12} md={3} lg={3} sx={{ ml: 1 }}>
                    <TextField
                      id="yrbook"
                      error={data.errorStatus.date == true ? true : false}
                      label="Journal Voucher Date"
                      variant="outlined"
                      disabled={viewMode == true ? true : false}
                      size="small"
                      type="date"
                      required={data.date === '' ? true : false}
                      value={data.date}
                      onChange={(e) => {
                        const value = e.target.value;
                        handleInvoiceDateChanges(value);
                      }}
                      onKeyDown={(e) => {
                        let updatedTableArr = [...Rows];
                        const zeroSalesIndex = updatedTableArr.findIndex((row) => row.ledgerAccount.value === '');
                        const element = 'ledgerAccount' + zeroSalesIndex;
                        const warMsg = '';
                        const name = 'date';
                        const currentId = 'yrbook';
                        const nextId = element;
                        const prevID = 'sereisVouchers';
                        const required = true;
                        handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
                      }}
                      InputProps={{
                        inputProps: {
                          min:
                            // params?.id && !isNaN(params.id)
                            //   ? firstInvoiceDate ||
                            //     moment(startDate * 1000).format("YYYY-MM-DD")
                            //   : lastInvoiceDate ||
                            firstInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD'),

                          max:
                            // params?.id && !isNaN(params.id)
                            //   ? nextInvoiceDate ||
                            //     moment(endDate * 1000).format("YYYY-MM-DD")
                            //   :
                            moment(endDate * 1000).format('YYYY-MM-DD'),
                        },
                      }}
                      fullWidth
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                          color: 'input.font',
                        },
                        '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                          borderColor: 'input.border',
                        },
                        '.css-1cqhiog-MuiInputBase-root-MuiOutlinedInput-root': {
                          color: 'input.font',
                        },
                        '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                          color: 'input.font',
                        },
                        '.MuiFormLabel-asterisk': {
                          color: 'danger.main',
                          fontSize: '16px',
                          fontWeight: 'bold',
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <Typography
                      sx={{
                        marginTop: '2px',
                        marginLeft: '10px',
                        marginBottom: '0px',
                        fontSize: '11px',
                        color: 'danger.main',
                      }}
                    >
                      {data?.errorFields.date}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                flex: { xs: 1, md: 0.5 },
                marginRight: { xs: 0, md: 0 },
                marginLeft: { xs: 0, md: 0 },
                marginTop: '16px',
                // borderRadius: "8px",
                // boxShadow:
                //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                padding: { xs: '10px 0px', sm: '0px 0px' },
                // borderRadius: "8px",
                ':hover': {
                  boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
                },
                transition: 'all 1s ease-in-out',
                marginBottom: { xs: 2, md: 0 },
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  // borderRadius: "12px",
                  overflow: 'hidden',
                  boxShadow: 'none',
                  '.MuiTableCell-root': {
                    padding: '0px 5px',
                    fontSize: '13px',
                  },
                  '.MuiTableCell-head': {
                    backgroundColor: 'background.tablebg',
                    padding: '10px 8px',
                    borderBottom: '0px',
                    fontSize: '13px',
                    fontWeight: 'bold',
                  },
                }}
              >
                <Box sx={{ padding: '0px 0px' }}>
                  <TableContainer
                    sx={{
                      maxHeight: 440,
                      '&::-webkit-scrollbar': {
                        width: '0.4em',
                        height: '0.4em',
                      },
                      '&:hover::-webkit-scrollbar': {
                        width: '0.6em',
                      },
                      // pointerEvents:
                      //   viewMode === true ? "auto !important" : "none",
                    }}
                  >
                    <Table className={classes.table} stickyHeader>
                      <TableHead>
                        <TableRow>
                          {headCell.map((column) => {
                            if (viewMode != true) {
                              return (
                                <TableCell
                                  align={column.align}
                                  key={column.id}
                                  min-Width={column.width}
                                  sx={{
                                    position: column.id == 'action' ? 'sticky' : '',
                                    right: column.id == 'action' ? 0 : '',
                                  }}
                                >
                                  {column.label} {column.required}
                                </TableCell>
                              );
                            } else {
                              return (
                                column.label != 'Action' && (
                                  <TableCell align={column.align} key={column.id} width={column.width}>
                                    {column.label}
                                    {column.required}
                                  </TableCell>
                                )
                              );
                            }
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody className="focusTableCellBorder">
                        {
                          // transID === "" &&
                          Rows.length > 0 &&
                            Rows.map((column, index) => {
                              totalCredit += Number(column.credit);
                              totalDebit += Number(column.debit);

                              return (
                                <TableRow
                                  className={classes.table}
                                  sx={{
                                    height: '40px',
                                    borderCollapse: 'separate',
                                  }}
                                  tabIndex={-1}
                                  key={index}
                                >
                                  <TableCell
                                    sx={{
                                      minWidth: '200px',
                                      borderCollapse: 'separate',
                                      border:
                                        column?.ledgerAccount?.value === '' && rowValidStatus === false
                                          ? '2px solid #e55353 !important'
                                          : '',
                                    }}
                                  >
                                    <Autocomplete
                                      disablePortal
                                      openOnFocus
                                      autoFocus
                                      id={'ledgerAccount' + index}
                                      name={'ledgerAccount' + index}
                                      disableClearable
                                      componentsProps={{
                                        popper: {
                                          style: { width: 'fit-content' },
                                        },
                                      }}
                                      options={[
                                        'Add Accounts',
                                        ...accName.sort((a, b) => {
                                          if (a.label < b.label) return -1;
                                          if (a.label > b.label) return 1;
                                          return 0;
                                        }),
                                      ]}
                                      disabled={viewMode == true ? true : false}
                                      isOptionEqualToValue={(option, value) => option?.value == value?.value}
                                      value={column?.ledgerAccount}
                                      onChange={(e, newValue) => {
                                        const updatedTableRow = [...Rows];
                                        if (newValue.value !== 'addAccount') {
                                          displayRowTwoBalance(newValue.value, index, updatedTableRow, transArr);
                                          e.preventDefault();

                                          updatedTableRow[index] = {
                                            ...updatedTableRow[index],
                                            ledgerAccount: newValue,
                                          };
                                          setRows(updatedTableRow);
                                          setRowsInd(index);
                                        }
                                      }}
                                      sx={{
                                        // Style the input text color conditionally
                                        '.MuiAutocomplete-input': {
                                          color: column?.debit !== 0 ? '#396afc' : column?.credit !== 0 ? '#20e0cf' : '',
                                          fontWeight: 'bold',
                                        },

                                        // Remove borders for the outlined input root
                                        '& .MuiOutlinedInput-root': {
                                          border: 'none !important',
                                          outline: 'none !important',
                                          boxShadow: 'none !important',
                                          '&:hover': {
                                            border: 'none !important',
                                            outline: 'none !important',
                                            boxShadow: 'none !important',
                                          },
                                          '&.Mui-focused': {
                                            border: 'none !important',
                                            outline: 'none !important',
                                            boxShadow: 'none !important',
                                          },
                                          '& fieldset': {
                                            border: 'none !important',
                                          },
                                        },

                                        // Input field itself
                                        '& .MuiOutlinedInput-input': {
                                          outline: 'none !important',
                                        },

                                        // Just in case any parent/focus ring
                                        '&:focus-visible': {
                                          outline: 'none !important',
                                          boxShadow: 'none !important',
                                        },

                                        // TextField root (extra safeguard)
                                        '& .MuiInputBase-root': {
                                          border: 'none !important',
                                          outline: 'none !important',
                                          boxShadow: 'none !important',
                                        },
                                      }}
                                      onKeyDown={(e) => {
                                        const warMsg = ' Ledger Account is required';

                                        const currentId = 'ladgerAccount' + index;
                                        const nextId = 'debit' + index;
                                        const prevID = index === 0 ? 'yrbook' : 'ledgerAccount' + (index - 1);
                                        const required = true;
                                        handleEntryAutoCompleteKeyDown(
                                          e,

                                          currentId,
                                          nextId,
                                          required,
                                          warMsg,
                                          prevID
                                        );
                                      }}
                                      size="small"
                                      renderOption={(props, option) => (
                                        <>
                                          {option === 'Add Accounts' ? (
                                            <MenuItem
                                              value={'addAccount'}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                const updatedTableArr = [...Rows];
                                                setUpdatedTableRow(updatedTableArr);
                                                setRowsInd(index);
                                                setToAccountModal(true);
                                                setAddAccountEvent(true);
                                                setRowOneAccModalOpen(false);
                                              }}
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                position: 'sticky',

                                                top: '-8px',
                                                mt: '-8px',
                                                zIndex: 1,
                                                backgroundColor: grey[50],
                                                '&:hover': {
                                                  backgroundColor: grey[200],
                                                },
                                              }}
                                            >
                                              <AddBox
                                                fontSize="small"
                                                sx={{
                                                  marginRight: '5px',
                                                  color: 'primary.main',
                                                }}
                                              />
                                              <ListItemText sx={{ color: 'primary.main' }} primary={'Add Accounts'} />
                                            </MenuItem>
                                          ) : (
                                            <li {...props}>
                                              <span>
                                                <b>{option.label}</b>{' '}
                                                {option?.groupName?.length ? <i>({option?.groupName?.trim()})</i> : ''}
                                              </span>
                                            </li>
                                          )}
                                        </>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          {...params}
                                          required={true}
                                        />
                                      )}
                                    />
                                  </TableCell>
                                  <TableCell
                                    // tabIndex="0"
                                    id={'currentBalance' + index}
                                    sx={{ minWidth: '200px', outline: 'none' }}
                                    align="right"
                                    onKeyDown={(e) => {
                                      const warMsg = ' ';

                                      const currentId = 'currentBalance' + index;
                                      const nextId = 'debit' + index;
                                      const prevID = 'ledgerAccount' + index;
                                      const required = false;
                                      handleEntryAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
                                    }}
                                  >
                                    {column?.currentBalance !== '' && (
                                      <Link
                                        underline="none"
                                        // sx={{ cursor: "pointer" }}
                                      >
                                        {Number(column?.currentBalance) === 0 || isNaN(column?.currentBalance)
                                          ? ''
                                          : Number(column?.currentBalance) < 0
                                          ? MoneyFormatv3(column?.currentBalance * -1) + ' ' + 'Dr'
                                          : Number(column?.currentBalance) > 0
                                          ? MoneyFormatv3(column?.currentBalance) + ' ' + 'Cr'
                                          : MoneyFormat(column?.currentBalance)}
                                      </Link>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      minWidth: '200px',
                                      borderCollapse: 'separate',
                                      border:
                                        column?.credit == 0 && column?.debit == 0 && rowValidStatus === false
                                          ? '2px solid #e55353 !important'
                                          : '',
                                    }}
                                    align="right"
                                  >
                                    <TextField
                                      name={'debit' + index}
                                      id={'debit' + index}
                                      variant="outlined"
                                      size="small"
                                      type="text"
                                      onClick={moveCursorToEnd}
                                      disabled={column?.ledgerAccount?.value === '' || viewMode === true ? true : false}
                                      value={getDisplayValue(column?.debit, `debit${index}`)}
                                      fullWidth
                                      required={column?.credit == '' ? true : false}
                                      onChange={(e) => {
                                        let value = e.target.value;

                                        value = value.replace(/,/g, '');
                                        if (!/^-?\d*(?:\.\d*)?$/.test(value)) {
                                          return;
                                        }
                                        const maxLimit = 1000000000; // 10 crore in numerical form
                                        if (parseFloat(value) > maxLimit) {
                                          return;
                                        }
                                        if (/^-?\d*\.?\d{0,2}$/.test(value) == false) {
                                          return;
                                        }

                                        if (!/^\d*(?:\.\d*)?$/.test(value)) {
                                          return;
                                        }

                                        getTotalDebitCreditByDebit(value, index);
                                        setRowsInd(index);
                                      }}
                                      onFocus={() => {
                                        setFocusedField(`debit${index}`);
                                      }}
                                      onBlur={() => {
                                        setFocusedField(null);
                                        const updatedTableArr = [...Rows];
                                        formatNumbers(index, 'debit', updatedTableArr[index]?.debit);
                                      }}
                                      onKeyDown={(e) => {
                                        const warMsg = ' ';

                                        const currentId = 'debit' + index;
                                        const nextId = 'credit' + index;
                                        const prevID = 'ledgerAccount' + index;
                                        const required = false;
                                        handleEntryTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
                                      }}
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          border: 'none',
                                          outline: 'none',
                                          boxShadow: 'none',
                                          '&:hover': {
                                            border: 'none',
                                            outline: 'none',
                                          },
                                          '&.Mui-focused': {
                                            border: 'none',
                                            outline: 'none',
                                            boxShadow: 'none',
                                          },
                                          '& fieldset': {
                                            border: 'none !important',
                                          },
                                        },

                                        // Extra safety to remove outline from input itself
                                        '& .MuiOutlinedInput-input': {
                                          outline: 'none',
                                        },

                                        // Remove global focus-visible ring
                                        '&:focus-visible': {
                                          outline: 'none',
                                          boxShadow: 'none',
                                        },
                                        outline: 'none',
                                        '& input': {
                                          textAlign: 'right',
                                          color: '#396afc',
                                          fontWeight: 'bold',
                                          // Fix for autofill / autocomplete styles:
                                          WebkitTextFillColor: '#396afc',
                                          // For Firefox:
                                          MozTextFillColor: '#396afc',
                                        },
                                        // Fix autofill background color (Chrome):
                                        '& input:-webkit-autofill': {
                                          WebkitBoxShadow: '0 0 0 1000px white inset',
                                          WebkitTextFillColor: '#396afc',
                                        },
                                      }}
                                      InputProps={{
                                        inputProps: {
                                          min: 0,
                                        },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      borderCollapse: 'separate',
                                      minWidth: '200px',
                                      border:
                                        column?.credit == 0 && column?.debit == 0 && rowValidStatus === false
                                          ? '2px solid #e55353 !important'
                                          : '',
                                    }}
                                    align="right"
                                  >
                                    <TextField
                                      name={'credit' + index}
                                      id={'credit' + index}
                                      variant="outlined"
                                      size="small"
                                      type="text"
                                      onClick={moveCursorToEnd}
                                      disabled={column?.ledgerAccount.value === '' || viewMode === true ? true : false}
                                      value={getDisplayValue(column?.credit, `credit${index}`)}
                                      required={column.debit == '' ? true : false}
                                      fullWidth
                                      onChange={(e) => {
                                        let value = e.target.value;

                                        value = value.replace(/,/g, '');

                                        if (!/^-?\d*(?:\.\d*)?$/.test(value)) {
                                          return;
                                        }
                                        if (/^-?\d*\.?\d{0,2}$/.test(value) == false) {
                                          return;
                                        }
                                        if (!/^\d*(?:\.\d*)?$/.test(value)) {
                                          return;
                                        }
                                        const maxLimit = 1000000000; // 10 crore in numerical form
                                        if (parseFloat(value) > maxLimit) {
                                          return;
                                        }

                                        getTotalDebitCreditByCredit(value, index);
                                        setRowsInd(index);
                                      }}
                                      onFocus={() => {
                                        setFocusedField(`credit${index}`);
                                      }}
                                      onBlur={() => {
                                        setFocusedField(null);
                                        const updatedTableArr = [...Rows];
                                        formatNumbers(index, 'credit', updatedTableArr[index]?.credit);
                                      }}
                                      onKeyDown={(e) => {
                                        const warMsg = 'Debit/Credit Amount is required ';

                                        const currentId = 'credit' + index;
                                        const nextId = 'description' + index;
                                        const prevID = 'debit' + index;
                                        const required = column?.debit === '' || column?.debit == 0 ? true : false;
                                        handleEntryTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
                                      }}
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          border: 'none',
                                          outline: 'none',
                                          boxShadow: 'none',
                                          '&:hover': {
                                            border: 'none',
                                            outline: 'none',
                                          },
                                          '&.Mui-focused': {
                                            border: 'none',
                                            outline: 'none',
                                            boxShadow: 'none',
                                          },
                                          '& fieldset': {
                                            border: 'none !important',
                                          },
                                        },

                                        // Extra safety to remove outline from input itself
                                        '& .MuiOutlinedInput-input': {
                                          outline: 'none',
                                        },

                                        // Remove global focus-visible ring
                                        '&:focus-visible': {
                                          outline: 'none',
                                          boxShadow: 'none',
                                        },
                                        outline: 'none',
                                        '& input': {
                                          textAlign: 'right',
                                          color: '#20e0cf',
                                          fontWeight: 'bold',
                                          WebkitTextFillColor: '#20e0cf', // For Chrome autofill text color
                                          MozTextFillColor: '#20e0cf', // For Firefox autofill text color
                                        },
                                        '& input:-webkit-autofill': {
                                          WebkitBoxShadow: '0 0 0 1000px white inset', // autofill bg fix
                                          WebkitTextFillColor: '#20e0cf',
                                        },
                                      }}
                                      InputProps={{
                                        inputProps: {
                                          min: 0,
                                        },
                                      }}
                                      onKeyPress={(event) => {
                                        if (event?.key === '-' || event?.key === '+') {
                                          event.preventDefault();
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      name={'description' + index}
                                      id={'description' + index}
                                      size="small"
                                      disabled={column?.ledgerAccount.value === '' || viewMode === true ? true : false}
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          border: 'none',
                                          outline: 'none',
                                          boxShadow: 'none',
                                          '&:hover': {
                                            border: 'none',
                                            outline: 'none',
                                          },
                                          '&.Mui-focused': {
                                            border: 'none',
                                            outline: 'none',
                                            boxShadow: 'none',
                                          },
                                          '& fieldset': {
                                            border: 'none !important',
                                          },
                                        },

                                        // Extra safety to remove outline from input itself
                                        '& .MuiOutlinedInput-input': {
                                          outline: 'none',
                                        },

                                        // Remove global focus-visible ring
                                        '&:focus-visible': {
                                          outline: 'none',
                                          boxShadow: 'none',
                                        },
                                        outline: 'none',
                                      }}
                                      value={column?.description}
                                      fullWidth
                                      onChange={(e) => {
                                        const updatedTableRows = [...Rows];
                                        const value = e.target.value;
                                        updatedTableRows[index] = {
                                          ...updatedTableRows[index],
                                          description: value,
                                        };
                                        setRows(updatedTableRows);
                                        setRowsInd(index);
                                      }}
                                      // onKeyDown={(e) => {
                                      //   const warMsg = '';

                                      //   const currentId = 'description' + index;
                                      //   const nextId = 'link' + index;
                                      //   const prevID = 'credit' + index;
                                      //   const required = false;
                                      //   handleEntryTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
                                      // }}
                                      onKeyDown={(e) => {
                                        const updatedTableRow = [...Rows];
                                        if (e.key === 'Tab' && e.shiftKey) {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          const element = document.getElementById(`credit${index}`);
                                          element?.focus();
                                        }
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          if (index < updatedTableRow.length - 1) {
                                            // Proper concatenation of index + 1
                                            const element = document.getElementById(`ledgerAccount${index + 1}`);
                                            element?.focus(); // Focus the element if it exists
                                          } else {
                                            saveChangesInRows(index);
                                          }
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  {/* <TableCell
                                    id={'link' + index}
                                    tabIndex="0"
                                    // sx={{ outline: "pointer" }}
                                    onKeyDown={(e) => {
                                      const updatedTableRow = [...Rows];
                                      if (e.key === 'Tab' && e.shiftKey) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        const element = document.getElementById(`description${index}`);
                                        element?.focus();
                                      }
                                      if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (index < updatedTableRow.length - 1) {
                                          // Proper concatenation of index + 1
                                          const element = document.getElementById(`ledgerAccount${index + 1}`);
                                          element?.focus(); // Focus the element if it exists
                                        } else {
                                          saveChangesInRows(index);
                                        }
                                      }
                                    }}
                                  >
                                    {' '}
                                    <Link
                                      underline="none"
                                      // sx={{ cursor: "pointer" }}
                                    ></Link>{' '}
                                  </TableCell> */}
                                  {viewMode !== true && (
                                    <TableCell
                                      align="right"
                                      onFocus={(e) => {
                                        setFocusCell('rowAction');
                                      }}
                                      onBlur={() => {
                                        setFocusCell('');
                                      }}
                                      // className="actionBackGround"
                                    >
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                        }}
                                      >
                                        <IconButton
                                          disableRipple={false}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            backgroundColor: '#fbc7c7',
                                          }}
                                          onClick={() => {
                                            if (viewMode != true) {
                                              closeChangesInRows(index);
                                            }
                                          }}
                                        >
                                          <CloseIcon
                                            sx={{
                                              fontSize: '18px',
                                              color: '#eb6a6a',
                                            }}
                                          />
                                        </IconButton>
                                        {/* )} */}
                                      </Box>
                                    </TableCell>
                                  )}
                                </TableRow>
                              );
                            })
                        }
                        {Rows.length === 0 && (
                          <TableRow sx={{ height: '40px' }}>
                            <TableCell align="center" colSpan={7}>
                              No Items Found
                            </TableCell>
                          </TableRow>
                        )}

                        <TableRow></TableRow>
                        {viewMode !== true && (
                          <TableRow sx={{ height: '40px' }} className={classes.stickyRow}>
                            <TableCell colSpan={7}>
                              <Box>
                                <Button
                                  id="Action"
                                  size="small"
                                  variant="text"
                                  onClick={() => {
                                    if (viewMode !== true) {
                                      saveChangesInRows('');
                                    }
                                  }}
                                  startIcon={<AddBox />}
                                  sx={{
                                    fontSize: '14px',
                                  }}
                                >
                                  Add New Line
                                </Button>
                              </Box>
                            </TableCell>
                          </TableRow>
                        )}
                        {/* {Rows.length > 0 && ( */}
                        <TableRow sx={{ height: '40px' }} className={classes.stickyRow}>
                          <TableCell sx={{ fontWeight: 600 }}>Total (₹)</TableCell>
                          <TableCell></TableCell>
                          <TableCell align="right">
                            <Typography sx={{ fontWeight: 600, mr: '12px' }}>
                              {MoneyFormatv3(Number(totDbtAmt).toFixed(2), 'en-IN')}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography sx={{ fontWeight: 600, mr: '12px' }}>
                              {MoneyFormatv3(Number(totCdtAmt).toFixed(2), 'en-IN')}
                            </Typography>
                          </TableCell>
                          {/* <TableCell></TableCell> */}
                          <TableCell></TableCell>
                          {viewMode !== true && <TableCell></TableCell>}
                        </TableRow>
                        {/* )} */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {totDiffAmt !== 0 && (
                    <Typography
                      textAlign="center"
                      color={
                        // theme?.palette?.TmId.id.toString().includes("9") ||
                        // params?.view == true
                        //   ? "white"
                        //   : Number(totDiffAmt) === 0
                        //   ? "input.label"
                        //   :
                        'red'
                      }
                      sx={{
                        fontSize: '15px',
                        padding: '10px ',
                        fontWeight: 600,
                        mr: '200px',
                      }}
                    >
                      {'      '}
                      Difference :{' '}
                      <span
                        style={{
                          fontWeight: 600,
                          color: Number(totDiffAmt) === 0 ? '' : 'red',
                        }}
                      >
                        {MoneyFormatv3(Number(totDiffAmt).toFixed(2), 'en-IN')}
                      </span>
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                borderRadius: '8px',
                marginBottom: '20px',
                marginTop: '16px',
                // boxShadow:
                //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                padding: { xs: '10px 0px', sm: '10px 0px' },
                ':hover': {
                  boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
                },
                transition: 'all 1s ease-in-out',
              }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  container
                  lg={3}
                  xs={12}
                  sx={{
                    padding: '0px 10px',
                    display: 'flex',
                    flexDirection: 'column',
                    // marginTop: { xs: "15px" },
                  }}
                >
                  <TextField
                    error={data?.errorStatus?.remarks === true ? true : false}
                    id="Comments / Remarks"
                    label="Narration"
                    multiline
                    variant="outlined"
                    size="small"
                    disabled={viewMode}
                    fullWidth
                    value={data.remarks}
                    rows={8}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (e.target.value.length > 250) {
                        setData((prev) => ({
                          ...prev,
                          remarks: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            remarks: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            remarks: 'Narration must be less than 250 characters',
                          },
                        }));
                      }
                      setData((prev) => ({
                        ...prev,
                        remarks: e.target.value,
                        errorStatus: {
                          ...prev.errorStatus,
                          remarks: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          remarks: '',
                        },
                      }));
                    }}
                    sx={{
                      '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                        fontSize: '14px',
                      },
                      label: {
                        fontSize: '14px',
                      },
                      '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                        color: 'input.font',
                      },
                      '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                        borderColor: 'input.border',
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {data?.errorFields?.remarks}
                  </Typography>
                </Grid>
                <Grid container item xs={12} lg={9} md={12}>
                  <Grid item>
                    <Typography
                      sx={{
                        marginRight: '10px',
                        fontWeight: '600',
                        fontSize: '14px',
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                      }}
                      // variant="h6"
                    >
                      Documents
                    </Typography>
                  </Grid>

                  <Grid item>
                    <input
                      type="file"
                      id="fileInput"
                      onChange={handleFileChange}
                      multiple
                      disabled={data?.partyName?.value === ''}
                      style={{ display: 'none' }}
                      accept="
                    application/msword,
                    application/pdf,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.ms-excel,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    application/vnd.ms-powerpoint,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    image/jpeg,
                    image/png
                  "
                    />

                    <CustomTooltip title="Rolling out soon" placement="top">
                      <span>
                        <Button
                          onClick={() => document.getElementById('fileInput').click()}
                          size="small"
                          variant="contained"
                          // disabled={viewMode}
                          disabled={true}
                          disableRipple={false}
                        >
                          <Add fontSize="15px" />
                          {' ADD DOCUMENT'}
                          {itemsRows.length > 0 && <span style={{ color: 'white' }}>{'\xa0' + `(${itemsRows.length} out of 6)`}</span>}
                        </Button>
                      </span>
                    </CustomTooltip>
                  </Grid>
                  {itemsRows.length > 0 && (
                    <Grid item xs={12}>
                      <Attachment
                        view={viewMode}
                        attachments={itemsRows}
                        setAttachments={setItemsRows}
                        updateAttachmentName={updateAttachmentName}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>

        {/* {(viewMode == true ? entryData.cancelflag === 0 : true) ? ( */}
        <DraggableAction
          actionType={params?.id && params?.view !== true ? 'edit' : entryData?.cancelflag === 1 ? 'cancelled' : 'save'}
          onExit={() => {
            // setCancelModal(true);
            navigate('/journalentries', { force: true });
          }}
          onSave={
            params?.id && params?.view !== true
              ? () => {
                  saveEditChanges({ new: false });
                }
              : params?.view !== true
              ? () => saveChanges({ new: false })
              : null
          }
          onEnableEdit={() => {
            navigate('/editjournalentry', { state: { id: transID } });
          }}
          from={'JE'}
          onCancel={
            params?.view == true
              ? () => {
                  setCancelModalStatus(true);
                  setItemData({
                    id: params?.id,
                    from: 'Journal Entry',
                    fn: () => {
                      cancel();
                    },
                    todo: 'cancel',
                  });
                }
              : null
          }
          onDelete={
            params?.view == true || params?.id
              ? () => {
                  setCancelModalStatus(true);
                  setItemData({
                    id: params?.id,
                    from: 'Journal Entry',
                    fn: () => {
                      deleteEntry();
                    },
                    todo: 'delete',
                  });
                }
              : null
          }
          onSaveNew={params?.view !== true && modalEvent !== true ? () => saveChanges({ new: true }) : null}
          onReset={
            params?.view !== true
              ? () => {
                  setData(initialState1);
                  setRows([...initialState]);
                  setItemsRows(currentDouments);
                }
              : null
          }
        />
        {/* ) : null} */}
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
          <CircularProgress color="inherit" />
        </Backdrop>
        {modalOpen && <ConfirmExit open={modalOpen} setOpen={setModalOpen} reNavigate={reNavigate} />}
        {cancelModalStatus == true ? (
          <InvoiceCancel open={cancelModalStatus} setOpen={setCancelModalStatus} itemData={itemData} state={state} setState={setState} />
        ) : null}
        {deleteItemModal == true ? <DeleteJournalEntry open={deleteItemModal} setOpen={setDeleteItemModal} itemData={itemData} /> : null}
        <DeleteJournalEntries
          open={deleteEntriesModal}
          setEntryRows={setRows}
          setOpen={setDeleteEntriesModal}
          setSnakbarTex={showSuccessSnackbar}
          entryRows={Rows}
          entryRowsOne={RowsOne}
          rowsNo={rowsNo}
          setRowsOneInd={setRowsOneInd}
          setRowsInd={setRowsInd}
          setEntryRowsOne={setRowsOne}
          entryInd={entryInd}
          transArr={transArr}
          setTransArr={setTransArr}
          displayRowOneBalance={(id, ind, transArr) => displayRowOneBalance(id, ind, transArr)}
          displayRowTwoBalance={(id, ind, arr, transArr) => displayRowTwoBalance(id, ind, arr, transArr)}
        />
        {addAccountEvent === true && (
          <AddAccountModal
            open={toAccountModal}
            setOpen={setToAccountModal}
            setData={setRows}
            data={Rows}
            showSuccessSnackbar={showSuccessSnackbar}
            showWarningSnackbar={showWarningSnackbar}
            showErrorSnackbar={showErrorSnackbar}
            accountType={'ledgerAccount'}
            Type={'Journal'}
            setNonItemEditedRow={setRows}
            updatetedTableRow={updatetedTableRow}
            rowIndex={rowsInd}
            setNewPartyID={setNewPartyID}
            setSelectedGroupId={setSelectedGroupId}
            selelctedGroupId={selelctedGroupId}
            newPartyID={newPartyID}
            setNewPartyName={setNewPartyName}
            newPartyName={newPartyName}
          />
        )}

        <NewVoucherSettingsModal
          open={settingsModal}
          label={'Journal'}
          type={'Journal'} //invoice label
          setOpen={setSettingsModal}
        />
        <ConfirmCancel open={cancelModal} setOpen={setCancelModal} path="journalentries" />
      </Box>
    </Box>
  );
}

export default CreateManualJournal;
